/* ═══════════ WAITLIST PANEL · self contained, touches nothing else.
   Reads and controls the queue through two Supabase doors guarded by
   the same access word as the rest of the hub (localStorage ffhub_key).

   WAITLIST-27 · This file used to sit inline in sections/ff-data-hub.liquid
   and pushed that section past Shopify's 256 KB cap. It now loads from the
   section with defer, so it runs once the whole page is parsed and every
   element it looks up in snippets/ff-data-hub-waitlist.liquid already
   exists. Nothing else on the page calls into it or waits for it.
   If this file ever breaks, take its script tag out of the section and
   the rest of the hub carries on untouched. */
(function(){
  var SB_URL="https://obadckrukccwkjgpbsxa.supabase.co";
  var SB_KEY="sb_publishable_4DntR53dZydUazuyuPI3YQ_zg69PLYZ";
  /* The Worker address Start pings. It lived only inside the main hub
     script, so this panel never saw it and Start never woke the queue.
     The next scheduled beat still ran, only later. */
  var QUEUE_URL="https://quest-ai.fondlyframed.workers.dev";
  function key(){try{return localStorage.getItem("ffhub_key")||""}catch(e){return ""}}
  function el(id){return document.getElementById(id)}
  function rpc(name,body){
    return fetch(SB_URL+"/rest/v1/rpc/"+name,{
      method:"POST",
      headers:{"Content-Type":"application/json","apikey":SB_KEY,"Authorization":"Bearer "+SB_KEY},
      body:JSON.stringify(body)
    }).then(function(r){
      if(!r.ok)return r.text().then(function(t){throw new Error(t||("HTTP "+r.status))});
      return r.json();
    });
  }
  /* lastFeed STARTS AS null, NOT AN EMPTY STRING. An empty machine builds
     an empty feed string, which equalled the old starting value, so the
     repaint was skipped and the panel sat on "Loading..." forever. Nobody
     would ever have seen the empty state that was written for them. */
  var D=null, busy=false, confirmTimer=null, confirmArmed=false, lastFeed=null;
  var W38=null;
  /* WAITLIST-34 · fast passes, read once a minute (the module is near the end) */
  var FP={ready:false,list:[],byRow:{},counts:null,loadedAt:0,shown:30};
  var returningQueuePaint=null;
  /* The live queue payload deliberately stays small. Full machine history
     comes through its own paged door, so reading the first action cannot
     make the 20-second queue poll heavy or interfere with sending. */
  var HISTORY=null, historyTotal=0, historyMore=false, historyBusy=false;
  var historyUnavailable=false, historyMode="newest";

  /* JAN DOES NOT READ POSTGRES. A raw {"code":"P0001"...} blob tells him
     nothing he can act on. Every failure this panel can actually hit gets
     translated into the next thing to press. Anything unrecognised still
     shows its own words, trimmed, because a wrong guess is worse than a
     quote. */
  function plainErr(e, fallback){
    var m = (e && e.message) || "";
    try { var j = JSON.parse(m); if (j && j.message) m = j.message; } catch (x) {}
    if (/unknown action/.test(m))
      return "The database has not learned this button yet. Paste WAITLIST-13 into the Supabase SQL Editor, press Run, then press the refresh circle here.";
    if (/does not exist|schema cache/.test(m))
      return "That door is not installed in the database yet. Run the newest WAITLIST file in Supabase, then refresh this page.";
    if (/wrong access word|access/i.test(m))
      return "The access word was refused. Sign back in to the hub and try again.";
    if (/Failed to fetch|NetworkError|Load failed/.test(m))
      return "Couldn't reach the database. Check your connection, then press the refresh circle.";
    if (!m) return fallback;
    return fallback + " " + m.slice(0,120);
  }

  var noteT=null;
  function err(msg){
    var e=el("wl-err"); if(!e)return;
    e.className="fh-wl-err";
    if(msg){e.textContent=msg;e.style.display="block"}else{e.style.display="none"}
  }
  /* a quiet green line for things that went right, gone in 4 seconds */
  function note(msg){
    var e=el("wl-err"); if(!e)return;
    e.textContent=msg; e.className="fh-wl-err ok"; e.style.display="block";
    clearTimeout(noteT);
    noteT=setTimeout(function(){
      if(e.className.indexOf("ok")>-1){e.style.display="none";e.className="fh-wl-err"}
    },4000);
  }
  function esc(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")}
  function ago(iso){
    var s=Math.max(0,Math.round((Date.now()-new Date(iso).getTime())/1000));
    if(s<60)return s+"s ago"; if(s<3600)return Math.round(s/60)+"m ago";
    if(s<86400)return Math.round(s/3600)+"h ago"; return Math.round(s/86400)+"d ago";
  }
  var TYPE_WORDS={turn_opened:"Turn opened",getting_close:"Turn reminder event",missed_window:"Missed window",removed:"Removed from line",converted:"Bought a slot"};

  function historySort(a,b){
    var aa=String(a.at||""), bb=String(b.at||"");
    if(aa!==bb)return aa<bb?1:-1;
    return Number(b.hid||0)-Number(a.hid||0);
  }
  function mergeHistory(rows){
    var byId={}, merged=[], i, r;
    for(i=0;i<(HISTORY||[]).length;i++){
      r=HISTORY[i]; if(r&&r.hid!=null)byId[String(r.hid)]=r;
    }
    /* New server values win, because queued may have become sent since the
       older copy was painted. */
    for(i=0;i<(rows||[]).length;i++){
      r=rows[i]; if(r&&r.hid!=null)byId[String(r.hid)]=r;
    }
    for(var k in byId)if(Object.prototype.hasOwnProperty.call(byId,k))merged.push(byId[k]);
    merged.sort(historySort);
    HISTORY=merged;
  }
  function historyStatus(){
    var c=el("wl-history-count"), b=el("wl-history-first"); if(!c||!b)return;
    if(historyUnavailable){
      c.textContent="Newest 12 shown"; b.disabled=true;
      b.title="Run WAITLIST-17 to open complete history."; return;
    }
    if(HISTORY===null){c.textContent="Loading history…";b.disabled=true;return}
    if(historyMode==="first"){
      c.textContent="First "+HISTORY.length.toLocaleString()+" of "+historyTotal.toLocaleString();
      b.disabled=historyBusy; b.textContent="Back to newest";
      b.title="Return to the newest recorded actions."; return;
    }
    c.textContent=(historyMore||HISTORY.length<historyTotal)
      ? "Showing "+HISTORY.length.toLocaleString()+" of "+historyTotal.toLocaleString()
      : "All "+historyTotal.toLocaleString()+" loaded";
    b.disabled=historyBusy||historyTotal===0;
    b.textContent="Go to first action";
    b.title="Jump directly to the oldest recorded action without loading every middle row.";
  }
  function paintFeed(adjustForNewTop){
    if(!D)return;
    var rows=HISTORY===null?(D.events||[]):HISTORY;
    var feed="";
    rows.forEach(function(ev){
      feed+='<div class="fh-logrow"'+(ev.hid!=null?' data-hid="'+ev.hid+'"':"")+'><span class="lw"><b>'+(TYPE_WORDS[ev.type]||ev.type)+'</b> · '+esc(ev.name)+' ···'+esc(ev.tail)+'</span>'+
        (ev.type==="converted"?'<span class="fh-wl-sale">SALE</span>':'<span class="lx">'+(ev.sent?"Handed to Klaviyo":"Queued for Klaviyo")+"</span>")+
        '<span class="lt">'+ago(ev.at)+"</span></div>";
    });
    if(HISTORY!==null&&historyMode==="newest"&&historyMore){
      feed+='<div class="fh-wl-history-more">'+(historyBusy?"Loading older actions…":"Scroll for older actions")+'</div>';
    }
    if(feed!==lastFeed){
      var feedEl=el("wl-feed"), keepFeed=feedEl.scrollTop, oldHeight=feedEl.scrollHeight;
      lastFeed=feed;
      feedEl.innerHTML=feed||'<div class="fh-empty" style="padding:16px">No commission events yet.</div>';
      feedEl.scrollTop=keepFeed+(adjustForNewTop&&keepFeed>4?feedEl.scrollHeight-oldHeight:0);
    }
    historyStatus();
  }
  function refreshHistory(done){
    if(!key()||historyBusy||historyUnavailable||historyMode!=="newest"){if(done)done();return}
    historyBusy=true; historyStatus();
    var known={};
    (HISTORY||[]).forEach(function(e){if(e&&e.hid!=null)known[String(e.hid)]=true});
    rpc("datahub_waitlist_history",{p_key:key(),p_before_at:null,p_before_id:null,p_limit:100})
      .then(function(page){
        var addedTop=false;
        (page.events||[]).forEach(function(e){if(e&&e.hid!=null&&!known[String(e.hid)])addedTop=true});
        mergeHistory(page.events||[]);
        historyTotal=Number(page.total)||0;
        historyMore=HISTORY.length<historyTotal;
        paintFeed(addedTop);
      })
      .catch(function(e){
        var m=(e&&e.message)||"";
        if(/does not exist|schema cache|PGRST202/i.test(m))historyUnavailable=true;
      })
      .then(function(){historyBusy=false;paintFeed(false);if(done)done()});
  }
  function loadOlderHistory(done){
    if(historyBusy||!historyMore||!HISTORY||!HISTORY.length){if(done)done();return}
    var last=HISTORY[HISTORY.length-1];
    var failed=false;
    historyBusy=true; paintFeed(false);
    rpc("datahub_waitlist_history",{p_key:key(),p_before_at:last.at,p_before_id:last.hid,p_limit:100})
      .then(function(page){
        mergeHistory(page.events||[]);
        historyTotal=Number(page.total)||historyTotal;
        historyMore=!!page.more;
        paintFeed(false);
      })
      .catch(function(){
        failed=true;
        var c=el("wl-history-count"); if(c)c.textContent="Older actions did not load. Scroll to try again";
      })
      .then(function(){
        historyBusy=false; paintFeed(false);
        if(failed){historyStatus();return}
        if(done)done();
      });
  }
  function goToFirstAction(){
    var feedEl=el("wl-feed"); if(!feedEl||HISTORY===null)return;
    if(historyMode==="first"){
      historyMode="newest"; HISTORY=null; historyMore=false; lastFeed=null;
      paintFeed(false); refreshHistory(function(){feedEl.scrollTop=0});
      return;
    }
    if(historyBusy)return;
    historyBusy=true; historyStatus();
    rpc("datahub_waitlist_history_first",{p_key:key(),p_limit:100})
      .then(function(page){
        HISTORY=page.events||[]; HISTORY.sort(historySort);
        historyTotal=Number(page.total)||0; historyMore=false; historyMode="first";
        lastFeed=null; paintFeed(false); feedEl.scrollTop=feedEl.scrollHeight;
      })
      .catch(function(){
        var c=el("wl-history-count"); if(c)c.textContent="The first action did not load. Try again";
      })
      .then(function(){historyBusy=false;historyStatus()});
  }

  function chip(k,v,d,tip){
    var help=tip?' title="'+esc(tip)+'" aria-label="'+esc(k+": "+v+". "+tip)+'"':"";
    return '<div class="fh-chip"'+help+'><div class="ck">'+k+'</div><div class="cv">'+v+'</div><div class="cd">'+(d||"")+"</div></div>"
  }

  /* ---------- the whole person ---------- */
  var MON=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  /* stored E.164, read as a phone number. A number you cannot read at a
     glance is a number you cannot cross check against a Shopify order. */
  function fmtPhone(p){
    var raw=String(p||""), d=raw.replace(/\D/g,"");
    if(d.length===11&&d.charAt(0)==="1"){
      d=d.slice(1);
      return "("+d.slice(0,3)+") "+d.slice(3,6)+"-"+d.slice(6);
    }
    if(d.length===10&&!/^\+/.test(raw))return "("+d.slice(0,3)+") "+d.slice(3,6)+"-"+d.slice(6);
    /* International numbers stay in canonical +country-code form. Hiding
       the plus sign makes a French or UK number look like a broken US one. */
    return raw;
  }
  function fmtDay(iso){
    if(!iso)return "";
    var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso));
    if(!m)return String(iso);
    var mo=MON[Number(m[2])-1]||m[2];
    var yr=Number(m[1]), now=new Date().getUTCFullYear();
    return mo+" "+Number(m[3])+(yr===now?"":" "+yr);
  }
  var BUY_WORDS={shopify:"bought on the site",klaviyo:"bought before, per Klaviyo",both:"bought on the site and in Klaviyo"};

  /* the search box and the filters, both live only in the browser.
     ONE FILTER STATE, TWO SETS OF BUTTONS. The tabs answer "who are these
     people" and the legend answers "can the machine reach them", and they
     share wlFilter rather than stacking. Two filters at once would need a
     rule about which one wins, and every rule like that gets forgotten by
     the time it matters. */
  var wlFilter="all", wlSearch="";
  /* WAITLIST-18 · which of the miss buttons is pressed. 0 is "any number of
     misses", and any other number is that exact count. It is only read while
     wlFilter is "miss", and pressing a different group resets it, so there is
     never a hidden second filter narrowing a list he thinks is whole. */
  var missPick=0;
  /* WHAT A ROW'S COLOUR MEANS, worked out by the database, not here.
     go   their clock is done and the machine will reach them
     wait still counting, and ready holds the date it runs out
     off  skipped for a reason waiting does not fix
     Before WAITLIST-12 the database says nothing, so this answers "" and
     every colour, count and legend switches itself off rather than
     guessing. A hub that guesses green would send Jan looking for a text
     that is never coming. */
  function clockOf(r){return (r&&typeof r.rs==="string")?r.rs:""}
  /* WAITLIST-25 · TUESDAY MODE. First turns open on Tuesdays and every later
     turn on a booked Monday, so "ready" stops meaning "the machine may text
     them now". The groups follow the booking instead: a booked Tuesday, a
     wait for one, a miss with its Monday, a live link. Before WAITLIST-25 is
     installed the payload carries no mode, and every word below stays exactly
     what it was. */
  function isTue(){return !!(D&&D.first_turn_mode==="tuesday")}
  /* WAITLIST-26 · BOOKED AT JOIN. The reply says first_book_early once that
     SQL is in. Before it this is false, and every word stays the WAITLIST-25
     one. has26() is true once the reply carries the two new dials at all. */
  function early(){return isTue()&&D.first_book_early===true}
  function has26(){return isTue()&&typeof D.first_book_early==="boolean"}
  function hasOld(){var a=(D&&D.top)||[];return a.length>0&&Object.prototype.hasOwnProperty.call(a[0],"ol")}
  /* WAITLIST-21: sp is the page's number (none for a link, pause or STOP); p until that SQL runs */
  function hasSendOrder(){var a=(D&&D.top)||[];return a.length>0&&Object.prototype.hasOwnProperty.call(a[0],"sp")}
  function posWords(r){
    if(clockOf(r)==="out")return "out";
    if(!hasSendOrder())return "#"+r.p;
    return r.sp!=null?"#"+r.sp:"&middot;";
  }
  function hasClock(){
    var a=(D&&D.top)||[];
    return a.length>0 && clockOf(a[0])!=="";
  }

  /* ═══════════ A MISS IS ITS OWN GROUP ═══════════
     WAITLIST-18. Jan: "people who missed make sure it has a separate panel
     then just still waiting ... still waiting should just be people who
     signed up and are waiting."

     Still waiting held two different populations wearing one colour: people
     counting down their first three weeks, and people who had a buy window,
     let it run out, and are climbing back. The second group is the one worth
     chasing by hand and it was hidden inside the first.

     THE SPLIT COMES OUT OF STILL WAITING AND NOWHERE ELSE, on purpose. Ready
     now is the send order, so a person whose cooldown is already over still
     belongs in it whatever their history, or the panel would stop describing
     what the machine is about to do. And Not in the running outranks a miss,
     because an unsubscriber with a miss cannot be chased at all and belongs
     under the reason that stops him wasting the effort. Since WAITLIST-21 paused
     and STOP people sit under no pill, so the counts add up to the line minus them. */
  function missOf(r){var n=Number(r&&r.s);return (n>0&&isFinite(n))?n:0}
  /* THE LIMIT IS THE MACHINE'S, NEVER A NUMBER TYPED HERE. The payload has
     carried max_strikes since WAITLIST-9 and the hub has a control that
     changes it, so a hard 3 in this file would go quietly wrong the first
     time he touched that dial. Three is only the fallback for a payload old
     enough not to carry it. */
  function maxMiss(){var n=Number(D&&D.max_strikes);return (n>=1&&n<=10)?Math.floor(n):3}
  /* out = retired, which the machine does on the last miss. They are not in
     the line at all, so they arrive in their own list and never through
     queue_display. */
  function groupOf(r){
    var st=clockOf(r);
    if(st==="out")return "miss";
    if(st==="off")return r.t?"off":"";
    /* Tuesday mode: a miss is a miss whatever its clock says, a booked first
       turn is green, and everybody else in the running waits for a Tuesday */
    if(isTue()&&(st==="go"||st==="wait")){
      if(missOf(r)>0)return "miss";
      return r.ret?"go":"wait";
    }
    if(st!=="wait")return st;
    return missOf(r)>0?"miss":"wait";
  }
  /* THE RETIRED ARE A SECOND LIST, NOT MORE ROWS IN THE FIRST. Adding them to
     top would renumber the whole line, so the reading door sends them beside
     it. Until that paste is run this answers empty and the last miss button
     says so in words rather than showing a silent nothing. */
  /* ⛔ THE STRIPE IS KEYED ON THE GROUP, NOT ON THE CLOCK, and the first cut of
     this wave got it wrong. The row's class was still built from clockOf, so a
     misser wore clk-wait, the new .clk-miss rule named a class nothing emitted,
     and the amber stripe was dead CSS that read correctly in every source
     check. It only showed up in a picture. Out keeps its own mark because a
     retired person is not a fourth shade of the same thing. */
  function rowMark(r){var st=clockOf(r);return (st==="out"||st==="off")?st:groupOf(r)}
  function retiredRows(){var a=(D&&D.retired)||[];return (a&&a.length)?a:[]}
  function hasRetired(){return !!(D&&D.retired)}
  /* THE POOL A PRESS IS ASKING ABOUT. Missed is the one group whose people
     are not all in the line, so it reads both lists and lets matchesFilter
     do the narrowing. Sorting the retired into a specific miss button by
     hand here would be a second copy of the same rule, and the two copies
     would disagree the first time the miss limit moved. */
  function poolFor(){
    if(wlFilter==="miss"||wlFilter==="history")return ((D&&D.top)||[]).concat(retiredRows());
    return (D&&D.top)||[];
  }
  /* HELD BY HAND IS HELD MINUS THE TWO AUTOMATIC REASONS. A past buyer
     is held automatically and an unsubscriber is held automatically, so
     a plain "held" tab was simply the other two tabs added together and
     told him nothing he could act on. Subtracting them leaves exactly
     the people he paused himself, which is the only set he cannot find
     any other way. The HELD chip on the row is untouched, so he can
     still see at a glance that the machine will skip somebody. */
  function matchesFilter(r){
    if(wlFilter==="buyers")  return !!r.buy;
    if(wlFilter==="unsub")   return !!r.uns;
    /* WAITLIST-25 · the old list has its own tab. Paused means the people he
       paused himself, which is also exactly what Remove all takes there. */
    if(wlFilter==="handheld")return !!r.hold&&!r.buy&&!r.uns&&!r.ol;
    if(wlFilter==="oldlist") return !!r.ol;
    if(wlFilter==="history")return missOf(r)>0&&(missPick===0||missOf(r)===missPick);
    if(wlFilter==="miss"){
      if(groupOf(r)!=="miss")return false;
      return missPick===0||missOf(r)===missPick;
    }
    if(wlFilter==="go"||wlFilter==="wait"||wlFilter==="off")return groupOf(r)===wlFilter;
    /* Everyone means the line. The retired are out of it, and folding them
       into the default view would put people the machine will never text
       again in the middle of the send order. */
    return clockOf(r)!=="out";
  }
  // Display-only accounting. Assign each listed person once; flags can overlap.
  // Cooldown totals are separate from saved strikes and never create miss history.
  function waitlistCounts(){
    var rows=(D&&D.top)||[], c={total:rows.length,go:0,wait:0,miss:0,off:0,
      paused:0,buyers:0,unsub:0,other:0,rotation:0,excluded:0,history:0,overlap:0};
    for(var i=0;i<rows.length;i++){
      var r=rows[i], g=groupOf(r);
      if(missOf(r)>0)c.history++;
      if(r.buy&&r.uns)c.overlap++;
      if(g==="go"||g==="wait"||g==="miss"||g==="off"){c[g]++;c.rotation++}
      else if(r.buy)c.buyers++;
      else if(r.uns)c.unsub++;
      else if(r.hold)c.paused++;
      else c.other++;
    }
    c.excluded=c.total-c.rotation;
    var ret=retiredRows();
    for(var j=0;j<ret.length;j++)if(missOf(ret[j])>0)c.history++;
    return c;
  }
  function paintBreakdown(c){
    var box=el("wl-breakdown");if(!box)return;
    box.hidden=!hasClock();if(box.hidden)return;
    var full=c.total===Number(D.in_line), n=function(v){return v.toLocaleString()};
    if(isTue()){
      /* the old list is part of paused, counted once, never a fourth pile */
      var rows=(D&&D.top)||[], old=0;
      for(var i=0;i<rows.length;i++)if(rows[i].ol&&rows[i].hold&&!rows[i].buy&&!rows[i].uns&&!groupOf(rows[i]))old++;
      box.innerHTML='<p class="fh-wl-total">'+(full?'Where all <b>'+n(c.total)+'</b> people are':'Breakdown of the <b>'+n(c.total)+'</b> people loaded here, out of '+n(Number(D.in_line)||0)+' listed')+'</p>'+
        '<div class="fh-wl-breakdown-cols"><div><strong>'+n(c.rotation)+' in the commission queue</strong><p>'+n(c.go)+' booked for Tuesday · '+n(c.wait)+' waiting for a Tuesday · '+n(c.miss)+' waiting after a miss · '+n(c.off)+' holding a buy link</p></div>'+
        '<div><strong>'+n(c.excluded)+' outside the commission queue</strong><p>'+n(old)+' older sign-ups on hold · '+n(c.paused-old)+' paused by you · '+n(c.buyers)+' bought before · '+n(c.unsub)+' unsubscribed'+(c.other?' · '+n(c.other)+' other':'')+'</p></div></div>'+
        '<p class="fh-wl-breakdown-note"><b>On hold for turns does not mean messages are off.</b> A returning person can be in warm-up while their commission turn waits. <a href="#wl-returning" data-open-warm>See the warm-up below</a>.</p>';
      return;
    }
    box.innerHTML='<p class="fh-wl-total">'+(full?'Where all <b>'+n(c.total)+'</b> people are':'Breakdown of the <b>'+n(c.total)+'</b> people loaded here, out of '+n(Number(D.in_line)||0)+' listed')+'</p>'+
      '<div class="fh-wl-breakdown-cols"><div><strong>'+n(c.rotation)+' in the commission queue</strong><p>'+n(c.go)+' ready now · '+n(c.wait)+' first wait · '+n(c.miss)+' waiting after a miss · '+n(c.off)+' open buy links</p></div>'+
      '<div><strong>'+n(c.excluded)+' outside the commission queue</strong><p>'+n(c.paused)+' on hold · '+n(c.buyers)+' bought before · '+n(c.unsub)+' unsubscribed'+(c.other?' · '+n(c.other)+' other / unavailable':'')+'</p></div></div>'+
      '<p class="fh-wl-breakdown-note"><b>Commission turns and warm-up messages are separate.</b> Starting the queue does not release individual pauses. '+
      (c.overlap?'Each person is counted once above. Someone who bought and unsubscribed shows under Bought before. ':'')+
      'In cooldown includes paused people and is separate from recorded misses.</p>';
  }
  function matchesSearch(r){
    if(!wlSearch)return true;
    var q=wlSearch;
    var hay=((r.full||r.n||"")+" "+(r.ph||"")+" "+(r.em||"")+" "+fmtPhone(r.ph)).toLowerCase();
    /* a typed number should find a stored +1 number, so digits match digits */
    var qd=q.replace(/\D/g,"");
    if(qd.length>=3&&String(r.ph||"").replace(/\D/g,"").indexOf(qd)>-1)return true;
    return hay.indexOf(q)>-1;
  }

  /* THE ROW SAYS IT IN WORDS TOO, read off the same flags as the chips, so the
     words and the chips can never contradict each other. */
  /* WAITLIST-22: a live link's time left, red under two hours like the page */
  function linkLeft(r){var m=Math.floor((Date.parse(r.dl)-Date.now())/60000);return !(m>=0)?"time up":(m>=60?Math.floor(m/60)+"h ":"")+(m%60)+"m left"}
  /* WAITLIST-25 · the day a booking lands, read on the machine's own clock,
     so a Monday is a Monday for him wherever his laptop is */
  var WKD=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  function tzDay(iso){
    var d=new Date(iso); if(isNaN(d.getTime()))return "";
    try{
      var parts=new Intl.DateTimeFormat("en-US",{timeZone:(D&&D.tz)||"America/Los_Angeles",weekday:"short",month:"short",day:"numeric"}).formatToParts(d);
      var w="",m="",dd="";
      for(var i=0;i<parts.length;i++){
        if(parts[i].type==="weekday")w=parts[i].value;
        if(parts[i].type==="month")m=parts[i].value;
        if(parts[i].type==="day")dd=parts[i].value;
      }
      if(w&&m&&dd)return w+" "+m+" "+dd;
    }catch(e){}
    return d.toDateString().slice(0,10);
  }
  function ymdDay(ymd){
    var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(String(ymd||"")); if(!m)return "";
    var d=new Date(Date.UTC(Number(m[1]),Number(m[2])-1,Number(m[3])));
    return WKD[d.getUTCDay()]+", "+MON[d.getUTCMonth()]+" "+d.getUTCDate();
  }
  function ymdShort(ymd){
    var w=ymdDay(ymd); return w?w.replace(",",""):"";
  }
  function tueWords(r){
    if(r.ret)return '<span class="fh-wl-when '+(missOf(r)?"miss":"go")+'">'+esc(tzDay(r.ret))+'</span>';
    /* every first turn is a Tuesday, so the estimate needs only the date */
    if(r.est)return '<span class="fh-wl-when wait">about '+esc(ymdDay(r.est).replace(/^[A-Za-z]+, /,""))+'</span>';
    return "";
  }
  function tueTitle(r){
    if(r.ret&&r.ret_why==="first")return "Booked for a first turn "+(r.ret_text||tzDay(r.ret))+(r.ret_picked?", the Tuesday they picked":"")+(early()?". The line texted them the day when it booked them. The reminders go the Friday before and the Monday before.":". The heads-up went out when the machine booked them.");
    if(r.ret&&missOf(r))return "Their link ran out "+(missOf(r)===1?"once":missOf(r)+" times")+". Their next turn opens "+(r.ret_text||tzDay(r.ret))+(r.ret_why==="asked"&&r.ret_picked?", the Monday they picked":"")+". The heads-up goes the Friday before.";
    if(r.ret)return "Booked for "+(r.ret_text||tzDay(r.ret))+".";
    if(r.est)return early()?"Waiting for a first turn. The next weekday run in your text hours books their Tuesday and texts them the day.":"Waiting for a first turn. Their place in line reaches about "+ymdDay(r.est)+". The machine books that Tuesday the Monday before at 10am.";
    return "";
  }
  function clockWords(r){
    var st=clockOf(r);
    if(!st)return "";
    if(isTue()&&(st==="go"||st==="wait")){var tw=tueWords(r);if(tw)return tw}
    if(isTue()&&st==="off"&&r.ol&&!r.t&&!r.uns)return '<span class="fh-wl-when off">turn on hold</span>';
    /* SHORT ON PURPOSE: it sits beside the name, the chips say the rest, and
       the tooltip carries the whole sentence. */
    /* the position column already says "out", so this column says the other
       half of the fact rather than the same word twice */
    if(st==="out")return '<span class="fh-wl-when out">retired</span>';
    if(st==="go")return '<span class="fh-wl-when go">ready now</span>';
    /* WAITLIST-18 · same date either way, because a miss and a fresh signup
       are both waiting on a clock. Only the word's colour changes, and it
       matches the stripe on the same row. */
    if(st==="wait")return '<span class="fh-wl-when '+(missOf(r)?"miss":"wait")+'">ready '+esc(fmtDay(r.ready))+'</span>';
    if(r.t)  return r.dl?'<span class="fh-wl-when off'+(Date.parse(r.dl)-Date.now()<72e5?' low':'')+'">'+linkLeft(r)+'</span>':'<span class="fh-wl-when off">up now</span>';
    if(r.uns)return '<span class="fh-wl-when off">unsubscribed</span>';
    if(r.hold)return '<span class="fh-wl-when off">paused</span>';
    return '<span class="fh-wl-when off">not in line</span>';
  }
  /* the long version of the same sentence, on the row itself, so the short
     column never has to carry the whole explanation */
  function clockTitle(r){
    var st=clockOf(r);
    if(isTue()&&(st==="go"||st==="wait")){var tt=tueTitle(r);if(tt)return tt}
    if(st==="off"&&r.ol&&!r.t&&!r.uns)return "This commission turn is on hold. Their warm-up may already be running. See Returning warm-up above for group progress.";
    if(st==="out")return "They missed "+missOf(r)+" buy windows, so the machine retired them and will not text them again. They are not in the line and hold no place in it.";
    if(st==="wait"&&missOf(r))return "Their buy window ran out "+(missOf(r)===1?"once":missOf(r)+" times")+". They are climbing back toward the front and the machine can reach them again on "+fmtDay(r.ready)+".";
    if(st==="wait")return "Three weeks is not up yet. No number of texts reaches them before "+fmtDay(r.ready)+".";
    if(st==="go")return "Their wait is over. The machine can text them, top of the line first.";
    if(st!=="off")return "";
    if(r.t)  return "They are holding a live buy link right now"+(r.dl?", until "+new Date(r.dl).toLocaleString([],{weekday:"short",hour:"numeric",minute:"2-digit"}):"")+", so the machine will not open another for them.";
    if(r.uns)return "They replied STOP or unsubscribed in Klaviyo, so no text can reach them. The machine skips them.";
    if(r.hold)return "You paused them. They keep their place in line and no turn will open for them until you press play.";
    return "Skipped for a reason waiting does not fix.";
  }
  /* ═══════════ HOW LONG THEY HAVE ACTUALLY WAITED ═══════════
     WAITLIST-18. Jan: "i should be able to see how long they've waited."
     The row already carried the day they joined, which answers that question
     only if you do the arithmetic against today, eight hundred times. This
     does it once per row.

     Whole days, counted in UTC on both ends, because joined arrives from the
     database as a UTC calendar date with no time on it. Comparing a date
     against a local clock is how a list like this ends up one day out for
     half the year. */
  function daysSince(iso){
    var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso||""));
    if(!m)return null;
    var then=Date.UTC(Number(m[1]),Number(m[2])-1,Number(m[3]));
    var n=new Date(), today=Date.UTC(n.getUTCFullYear(),n.getUTCMonth(),n.getUTCDate());
    var d=Math.round((today-then)/86400000);
    return d>=0?d:null;
  }
  /* PAST TENSE, ALWAYS. Jan: "why does it say waiting 21 days? not waited?"
     He is right and it was worth fixing. "waiting 21 days" is a sentence about
     what somebody INTENDS to do, so on a row it reads as a promise the machine
     is making about the future. The number is the opposite of that: it is time
     already spent, counted backwards from today, and only "waited" says so. It
     does not claim their wait is over either, because the same row still
     carries the date they turn green. */
  function waitedWords(r){
    var d=daysSince(r&&r.j);
    if(d===null)return "";
    if(d===0)return "waited less than a day";
    return "waited "+d+(d===1?" day":" days");
  }
  function wlRow(r){
    var tags="";
    var st=clockOf(r);
    if(r.t)tags+='<span class="fh-wl-turnchip">UP NOW</span>';
    /* WAITLIST-26 · a closed Monday can move a picked second chance. The move
       clears the picked stamp, so the chip only shows while the Monday is
       still the one they chose. */
    if(isTue()&&r.ret&&(r.ret_why==="asked"||r.ret_why==="first")&&r.ret_picked)tags+='<span class="fh-wl-climbchip" title="'+(r.ret_why==="first"?"They moved this Tuesday themselves, once.":"They picked this Monday themselves, after their miss.")+'">PICKED</span>';
    else if(r.r)tags+='<span class="fh-wl-climbchip">CLIMBING</span>';
    if(r.buy)tags+='<span class="fh-wl-buychip" title="'+esc(BUY_WORDS[r.bsrc]||"bought before")+'">BOUGHT</span>';
    if(r.uns)tags+='<span class="fh-wl-unschip" title="They replied STOP or unsubscribed in Klaviyo, so no text can reach them.">UNSUBBED</span>';
    /* WAITLIST-34 · how their fast pass is doing, if Jan sent them one */
    if(r.id&&FP.byRow[r.id])tags+=fpChip(FP.byRow[r.id]);
    if(r.hold&&r.ol)tags+='<span class="fh-wl-holdchip" title="On the old list. Old list seats bring them back, the people who joined first going first.">OLD LIST</span>';
    else if(r.hold)tags+='<span class="fh-wl-holdchip" title="Paused by you. They keep their place in line and the machine will not open a turn for them.">PAUSED</span>';

    var bits=[];
    /* JOINED BEFORE EMAIL, ON PURPOSE. The contact line ellipsises from the
       right, so whatever sits last dies first when a row runs tight. It used
       to be the joined date, which is the one bit with no other home on the
       row. An email losing its tail is still recognisable from its front,
       so the email pays for the ellipsis now and the date never does. */
    if(r.ph)bits.push(esc(fmtPhone(r.ph)));
    if(r.j)bits.push("joined "+esc(fmtDay(r.j)));
    /* WAITLIST-18 · the wait rides directly behind the joined date, which is
       the one bit this line already protects from the ellipsis. The email
       still pays for the overflow, so the two facts he asked to see are the
       two that never get cut. */
    var wd=waitedWords(r);
    if(wd)bits.push(esc(wd));
    if(missOf(r))bits.push(missOf(r)+(missOf(r)===1?" miss":" misses"));
    if(r.em)bits.push(esc(r.em));
    var w=clockWords(r);
    var ct=clockTitle(r);

    var acts="";
    /* WAITLIST-34 · the fast pass works for anybody on file, retired and past
       buyers included, so it sits outside the rule below. It shows only once
       the database answers for fast passes. */
    if(r.id&&FP.ready){
      var fpWords="Copy a fast pass link for "+esc(r.full||r.n)+". It skips them to the front and opens their spot on that page only";
      acts+='<button class="fh-wl-act pass" data-act="fastpass" data-tip="'+fpWords+'" title="'+fpWords+'" aria-label="'+fpWords+'">'+FP_ICON+'</button>';
    }
    /* WAITLIST-18 · A RETIRED ROW CARRIES NO BUTTONS, and that is a fact
       about the doors rather than a style choice. Ready now, front, back and
       the x all refuse anybody whose state is not waiting or turn_open, and
       pausing somebody the machine has already stopped texting does nothing
       at all. Five controls that answer with an error is worse than none. */
    /* WAITLIST-25 · a booked day is already a promise with a text behind it.
       Ready now and the back of the line mean nothing to it, so a booked row
       in Tuesday mode keeps only pause and remove. */
    var booked=isTue()&&!!r.ret;
    /* WAITLIST-26 · a first turn booked at join can still be made ready. The
       door drops the booked day and the next run books the soonest Tuesday
       with room. Somebody already made ready gets the undo instead. */
    var firstBooked=booked&&r.ret_why==="first"&&early()&&!r.early;
    if(r.id&&st!=="out"){
      /* READINESS AND ORDER ARE TWO DIFFERENT KNOBS. A red-clock person can
         be made ready without silently changing their place. The up arrow
         appears only once the same eligibility value used by queue_tick is
         green, so moving a red row can never trigger an early Almost Up or
         turn text by itself. */
      if(st==="wait"&&(!booked||firstBooked)){
        var readyWords=firstBooked
          ? "Ready now. The next run moves them to the soonest Tuesday with room, even inside "+(Number(D.first_turn_min_days)||12)+" days. If no sooner Tuesday has room, they keep their booked day"
          : isTue()
          ? "Ready now. They can take a Tuesday seat before "+(Number(D.first_turn_min_days)||12)+" days in line, and keep their place"
          : "Make ready now and keep their current position";
        acts+='<button class="fh-wl-act ready" data-act="ready_now"'+(firstBooked?' data-first="1"':'')+' data-tip="'+readyWords+'" title="'+readyWords+'" aria-label="'+readyWords+'">&#10003;</button>';
      }else if(r.early){
        var undoWords=Number(r.zone)===-1
          ? "Restore their normal waiting date and move them to the safe back"
          : "Restore their normal waiting date";
        acts+='<button class="fh-wl-act ready" data-act="normal_wait" data-tip="'+undoWords+'" title="'+undoWords+'" aria-label="'+undoWords+'">&#8630;</button>';
      }
      if(!r.t&&st==="go"&&!booked){
        acts+='<button class="fh-wl-act up" data-act="promote" data-tip="Move to the front of the line" title="Move to the front of the line" aria-label="Move to the front of the line">&uarr;</button>';
      }
      if(!r.t&&!booked){
        acts+='<button class="fh-wl-act down" data-act="demote" data-tip="Send to the back of the line" title="Send to the back of the line" aria-label="Send to the back of the line">&darr;</button>';
      }
      var holdWords=r.hold
        ? (r.ol?"Bring them back now. They take the next Tuesday seat their place reaches":"Resume them. They go back in the running")
        : "Pause them. They keep their place, and the line skips them";
      acts+='<button class="fh-wl-act hold'+(r.hold?" on":"")+'" data-act="'+(r.hold?"unhold":"hold")+'" data-tip="'+
          holdWords+'" title="'+holdWords+'" aria-label="'+holdWords+'">'+
          (r.hold?"&#9654;":"&#10073;&#10073;")+'</button>';
      acts+='<button class="fh-wl-act x" data-act="kick" data-tip="Remove from the waitlist" title="Remove from the waitlist" aria-label="Remove from the waitlist">&times;</button>';
    }

    return '<div class="fh-logrow'+(r.hold?" held":"")+(st?" clk-"+rowMark(r):"")+
      '"'+(ct?' title="'+esc(ct)+'"':"")+' data-wlid="'+(r.id||"")+
      '" data-wlname="'+esc(r.full||r.n)+'" data-hold="'+(r.hold?"1":"")+'" data-ol="'+(r.ol?"1":"")+'" data-zone="'+(Number(r.zone)||0)+'">'+
      /* a retired person holds no place, so the column says so instead of
         printing a position number that would be a guess */
      '<span class="fh-wl-pos">'+posWords(r)+'</span>'+
      '<span class="fh-wl-who">'+
        '<span class="fh-wl-name">'+esc(r.full||r.n)+'</span>'+
        '<span class="fh-wl-meta">'+(bits.join(" &middot; ")||"no contact details on file")+'</span>'+
      '</span>'+
      /* ITS OWN COLUMN, NOT THE END OF THE CONTACT LINE. Inside .fh-wl-meta
         it was governed by that line's ellipsis, so a thirty character
         email pushed "ready now" clean outside the clip and the row was
         left carrying its state in colour alone, which is the exact thing
         the words exist to prevent. */
      (w?'<span class="fh-wl-clockcol">'+w+'</span>':"")+
      '<span class="fh-wl-tags">'+tags+'</span>'+
      (acts?'<span class="fh-wl-acts">'+acts+'</span>':"")+
      '</div>';
  }

  /* ═══════════ REMOVING A WHOLE GROUP IN ONE PRESS ═══════════
     Forty six past customers is ninety two presses with the x button and
     one misfire lands on a stranger. One statement in the database does
     the same work, and because a removed person drops out of the line
     entirely they drop out of every tab at once. So cleaning the buyers
     first also empties them out of the unsubscribed tab, with no rule to
     remember about which order to do it in.

     THREE THINGS THIS HAS TO GET RIGHT:

     1. It asks twice. The first press arms, the second fires, and the
        arm falls off by itself after four seconds. Nothing here is worth
        a stray click.
     2. It says the real number, from the server, not the number the
        browser had on screen a moment earlier.
     3. It can be undone. The database stamps every row it removed with
        the moment of that clean, so one press puts that exact batch back
        in the exact places they held. */
  var GROUPN={buyers:0,unsub:0,handheld:0}, cleanArmed=false, cleanT=null, cleanBusy=false;
  /* THE UNDO HAS TO SURVIVE A REFRESH, because the moment he wants it is
     the moment he closes the tab in a panic and opens it again. The batch
     itself lives in the database and waits indefinitely; this is only the
     browser remembering to offer the button. If he presses it and the
     batch is already gone, the server says so in plain words. */
  var UNDO_LS="ff_wl_undo_v1";
  function undoFlag(v){
    try{ if(v===undefined)return !!localStorage.getItem(UNDO_LS);
         if(v)localStorage.setItem(UNDO_LS,"1"); else localStorage.removeItem(UNDO_LS); }catch(e){}
    return !!v;
  }
  var CLEAN_WHY={
    buyers:"They already bought, and the machine is already skipping them. This is tidying, not safety. They can rejoin from the page any time.",
    unsub:"They replied STOP, so no text can reach them. Nothing is lost by taking them out.",
    handheld:"Only the people you paused yourself. Not the past buyers and not the unsubscribers, those two have their own button."
  };
  function disarmClean(){
    clearTimeout(cleanT); cleanArmed=false;
    var b=el("wl-clean-go"); if(b)b.classList.remove("arm");
  }
  function paintClean(){
    var bar=el("wl-clean"); if(!bar)return;
    var g=wlFilter;
    if(g!=="buyers"&&g!=="unsub"&&g!=="handheld"){bar.className="fh-wl-clean";disarmClean();return}
    bar.className="fh-wl-clean on";
    el("wl-clean-undo").hidden=!undoFlag();
    var n=GROUPN[g]||0, btn=el("wl-clean-go");
    el("wl-clean-why").textContent=CLEAN_WHY[g]+(g==="handheld"&&hasOld()?" The old list stays too. It has its own tab.":"");
    btn.disabled=(n===0||cleanBusy);
    /* the red state is a class, not just words, because the words are
       small and the press is not reversible in one step. */
    if(cleanArmed)btn.classList.add("arm"); else btn.classList.remove("arm");
    if(cleanBusy){btn.textContent="Removing\u2026";return}
    if(cleanArmed){btn.textContent="Yes, remove "+n;return}
    btn.textContent=n?("Remove all "+n):"Nobody here to remove";
  }
  el("wl-clean-go").addEventListener("click",function(){
    var g=wlFilter, n=GROUPN[g]||0;
    if(!n||cleanBusy||busy)return;
    if(!cleanArmed){
      cleanArmed=true; paintClean();
      cleanT=setTimeout(function(){disarmClean();paintClean()},4000);
      return;
    }
    disarmClean();
    cleanBusy=true; busy=true; seq++; errSticky=false; paintClean();
    rpc("datahub_waitlist_control",{p_key:key(),p_action:"clean",p_value:null,p_text:g})
      .then(function(d){
        D=d; err(null); armedKey=null;
        var did=d&&d.did!=null?d.did:n;
        undoFlag(true); el("wl-clean-undo").hidden=false;
        note(did?("Removed "+did+" "+(did===1?"person":"people")+". Press \u201cput the last batch back\u201d if that was wrong."):"Nobody matched, so nothing was removed.");
      })
      .catch(function(e){
        errSticky=true;
        err(plainErr(e, "That clean didn\u2019t take, and nobody was removed."));
        setTimeout(function(){errSticky=false},20000);
      })
      .then(function(){cleanBusy=false;busy=false;paint()});
  });
  el("wl-clean-undo").addEventListener("click",function(){
    if(cleanBusy||busy)return;
    cleanBusy=true; busy=true; seq++; errSticky=false; paintClean();
    rpc("datahub_waitlist_control",{p_key:key(),p_action:"undo_clean",p_value:null,p_text:null})
      .then(function(d){
        D=d; err(null); armedKey=null;
        var did=d&&d.did!=null?d.did:0;
        undoFlag(false); el("wl-clean-undo").hidden=true;
        note("Put "+did+" "+(did===1?"person":"people")+" back, in the same places they held.");
      })
      .catch(function(e){
        errSticky=true;
        if((e.message||"").indexOf("no batch")>-1){undoFlag(false);el("wl-clean-undo").hidden=true}
        err((e.message||"").indexOf("no batch")>-1
          ? "There is no batch to put back. This only reverses a Remove all, never a single x."
          : plainErr(e, "That didn\u2019t take, and nobody moved."));
        setTimeout(function(){errSticky=false},20000);
      })
      .then(function(){cleanBusy=false;busy=false;paint()});
  });

  /* Drawn on its own so typing in the search box never waits on the
     server. The 20 second poll calls this too, through paint. */
  var lastTopKey="", armedKey=null;
  function paintTop(force){
    if(!D)return;
    /* a confirmation button is armed somewhere in this list. Rebuilding it now
       would swap the row out from under his finger. */
    if(armedKey&&!force)return;
    var all=D.top||[];
    var shown=[],buyers=0,unsubs=0,helds=0,olds=0;
    var totals=waitlistCounts();
    paintBreakdown(totals);
    /* counted here, in the same sweep that builds the rows, so the number
       on a legend pill and the number of rows behind it are the same read
       of the same array. Counting them separately is how two numbers on
       one screen start disagreeing. */
    var clock={go:0,wait:0,miss:0,off:0};
    /* WAITLIST-18 · one bucket per miss count, so the small buttons carry
       real numbers rather than making him press each one to find out. */
    var byMiss={};
    for(var i=0;i<all.length;i++){
      var r=all[i];
      if(r.buy)buyers++;
      if(r.uns)unsubs++;
      if(r.hold&&!r.buy&&!r.uns&&!r.ol)helds++;
      if(r.ol)olds++;
      var st=groupOf(r); if(st&&clock[st]!==undefined)clock[st]++;
      if(wlFilter==="history"?missOf(r)>0:st==="miss")byMiss[missOf(r)]=(byMiss[missOf(r)]||0)+1;
    }
    /* THE RETIRED ARE COUNTED INTO THE SAME PILL THEY ARE SHOWN UNDER.
       Missed with no sub-button pressed lists the line's missers and the
       retired together, so the pill has to count both or the number above
       the list would not be the length of the list. */
    var ret=retiredRows();
    for(var q=0;q<ret.length;q++){
      clock.miss++;
      if(missOf(ret[q])>0)byMiss[missOf(ret[q])]=(byMiss[missOf(ret[q])]||0)+1;
    }
    MISSN=byMiss;
    /* the rows themselves come from whichever pool the pressed buttons are
       asking about, which for the last miss button is the retired list */
    var pool=poolFor();
    for(var j=0;j<pool.length;j++){
      if(matchesFilter(pool[j])&&matchesSearch(pool[j]))shown.push(pool[j]);
    }
    GROUPN={buyers:buyers,unsub:unsubs,handheld:helds};
    var seg=el("wl-filter");
    if(seg){
      var bs=seg.getElementsByTagName("button");
      for(var b=0;b<bs.length;b++){
        var f=bs[b].getAttribute("data-f");
        /* "Everyone" only lights when nothing at all is filtering, so a
           legend press does not leave two things looking selected. */
        bs[b].className=(f===wlFilter?"on":"");
        bs[b].setAttribute("aria-pressed",String(f===wlFilter));
        if(f==="history")bs[b].textContent="All recorded misses ("+totals.history.toLocaleString()+")";
        if(f==="buyers")bs[b].textContent="Bought before"+(buyers?" ("+buyers+")":"");
        if(f==="unsub") bs[b].textContent="Unsubscribed"+(unsubs?" ("+unsubs+")":"");
        if(f==="handheld")bs[b].textContent="Paused"+(hasOld()?" by you":"")+(helds?" ("+helds+")":"");
        if(f==="oldlist"){bs[b].hidden=!hasOld();bs[b].textContent="Older sign-ups"+(olds?" ("+olds.toLocaleString()+")":"");}
      }
    }
    var context=el("wl-context");
    if(context)context.textContent=wlFilter==="oldlist"
      ? "Older sign-ups can include buyers and people who opted out. This filter is not the warm-up list. A turn can stay on hold while warm-up messages run."
      : isTue()&&wlFilter!=="history"&&wlFilter!=="miss"
      ? "Booked, Waiting, Missed and Up now leave out the old list, the people you paused and anybody who replied STOP. All recorded misses is a separate history view."
      : wlFilter==="history"
      ? "Saved miss counts across everyone, including ready, paused, previous buyers, unsubscribed and retired people. A cooldown can remain even when the saved miss count is zero."
      : wlFilter==="miss"
      ? "Waiting after a miss, plus retired people. Use All recorded misses to include people who are ready, paused, bought before or unsubscribed."
      : "Ready now, Still waiting, Missed and Up now exclude individual pauses and unsubscribe holds. All recorded misses is a separate history view.";
    paintLegend(clock);
    paintSub();
    /* THE DENOMINATOR IS THE POOL, NOT ALWAYS THE LINE. The last miss button
       reads a list the line does not contain, so "12 of 867" there would
       measure the answer against a set it never came from. */
    el("wl-hit").textContent=(wlFilter==="all"&&!wlSearch)
      ? all.length.toLocaleString()+" people listed"
      : shown.length.toLocaleString()+" of "+pool.length.toLocaleString();

    paintClean();

    var rows="";
    for(var k=0;k<shown.length;k++)rows+=wlRow(shown[k]);
    var stamp=wlFilter+"|"+missPick+"|"+wlSearch+"|"+rows;
    if(!force&&stamp===lastTopKey)return;
    lastTopKey=stamp;
    var topEl=el("wl-top"), keep=topEl.scrollTop;
    topEl.innerHTML=rows||'<div class="fh-wl-empty">'+emptyWords(all)+"</div>";
    topEl.scrollTop=keep;
  }

  /* THE LEGEND SWITCHES ITSELF OFF IF THE DATABASE HAS NOT LEARNED THE
     CLOCK YET. Jan pushes the theme and runs the SQL in two separate
     moments, and between them this panel must degrade to exactly what it
     was rather than showing three zeroes and no colours, which reads as
     "everybody is broken" instead of "one paste is still to do". */
  /* WAITLIST-25 · the same four pills, named for what they hold in Tuesday
     mode. The words and the tooltips swap back if he switches to the trickle. */
  var LEGEND={
    trickle:{go:["Ready now","Their three weeks is up. The machine will reach these people, top of the list first."],
             wait:["Still waiting","Signed up and counting down for the first time. Nobody here has ever had a buy window, and every row shows the date it turns green."],
             miss:["Missed","They had a buy window and it ran out. They are climbing back for another turn, and the smaller buttons underneath split them by how many times it has happened."],
             off:["Up now","Holding a live buy link right now. People you paused or who replied STOP are under Paused and Unsubscribed."]},
    early:{go:["Booked Tuesday","Booked for a first turn. The line texted them their day when it booked them. The reminders go the Friday before and the Monday before."],
             wait:["Waiting for a Tuesday","In line for a first turn. The next weekday run in your text hours books their Tuesday and texts them the day."],
             miss:["Missed","They had a turn and the link ran out. Each row shows the Monday their next turn opens, and the smaller buttons split them by how many times it has happened."],
             off:["Up now","Holding a live buy link right now. The old list, people you paused and STOP replies have their own tabs."]},
    tuesday:{go:["Booked Tuesday","Booked for a first turn. Their heads-up went out when the machine booked them, the Monday before at 10am."],
             wait:["Waiting for a Tuesday","In line for a first turn. Each row shows about which Tuesday their place reaches."],
             miss:["Missed","They had a turn and the link ran out. Each row shows the Monday their next turn opens, and the smaller buttons split them by how many times it has happened."],
             off:["Up now","Holding a live buy link right now. The old list, people you paused and STOP replies have their own tabs."]}
  };
  function paintLegend(clock){
    var box=el("wl-legend"); if(!box)return;
    if(!hasClock()){box.hidden=true;return}
    box.hidden=false;
    var words=LEGEND[early()?"early":(isTue()?"tuesday":"trickle")];
    var bs=box.getElementsByTagName("button");
    for(var i=0;i<bs.length;i++){
      var f=bs[i].getAttribute("data-f");
      bs[i].className="fh-wl-lg "+f+(wlFilter===f?" on":"");
      bs[i].setAttribute("aria-pressed",String(wlFilter===f));
      if(words[f]&&bs[i].getAttribute("data-words")!==words[f][0]){
        bs[i].setAttribute("data-words",words[f][0]);
        bs[i].title=words[f][1];
        bs[i].innerHTML="<i></i>"+esc(words[f][0])+" <b></b>";
      }
      var b=bs[i].getElementsByTagName("b")[0];
      if(b)b.textContent=(clock[f]||0).toLocaleString();
    }
    var why=box.querySelector(".fh-wl-lgwhy");
    if(why)why.textContent=(wlFilter==="go"||wlFilter==="wait"||wlFilter==="miss"||wlFilter==="off")
      ? "press it again for everyone"
      : "press one to see just those people";
  }

  /* ═══════════ THE MISS BUTTONS ═══════════
     WAITLIST-18. Jan: "in the missed tab we can separate into 3 smaller tabs
     of 1, 2, or 3 misses."

     Built from the machine's own limit, one button per possible miss count
     and an Any in front of them, so the row is right whatever that dial is
     set to. The LAST one is a different kind of answer and says so: on the
     final miss the machine retires somebody, which takes them out of the
     line entirely, so that button reads a separate list rather than
     filtering this one. */
  var MISSN={};
  function missLabel(n){return n+(n===1?" miss":" misses")}
  var ORD=["","first","second","third","fourth","fifth","sixth","seventh","eighth","ninth","tenth"];
  function ordMiss(n){return ORD[n]||(n+"th")}
  function paintSub(){
    var box=el("wl-sub"); if(!box)return;
    if((wlFilter!=="miss"&&wlFilter!=="history")||!hasClock()){box.hidden=true;box.innerHTML="";return}
    var top=maxMiss(), h="", n, on, cnt;
    h+='<button type="button" class="fh-wl-sb'+(missPick===0?" on":"")+'" data-m="0"'+
       ' aria-pressed="'+String(missPick===0)+'" title="All saved miss counts in this view.">Any<b>'+
       countAllMiss().toLocaleString()+'</b></button>';
    for(n=1;n<=top;n++){
      on=(missPick===n);
      cnt=MISSN[n]||0;
      h+='<button type="button" class="fh-wl-sb'+(on?" on":"")+'" data-m="'+n+'" title="'+
         (wlFilter==="history"
           ? esc("Exactly "+missLabel(n)+" recorded, whatever their current status. Viewing this does not release a hold.")
           : n>=top
           ? esc("The last miss. The machine retires them at "+missLabel(top)+", so these people are out of the line and no text will reach them again.")
           : esc("They have let "+n+(n===1?" buy window":" buy windows")+" run out and are still in the line, climbing back for another turn."))+
         '" aria-pressed="'+String(on)+'">'+esc(missLabel(n))+(n>=top&&wlFilter!=="history"?" · retired":"")+'<b>'+cnt.toLocaleString()+'</b></button>';
    }
    h+='<span class="fh-wl-subwhy">'+(missPick?"press it again for every miss count":"press one to see just that many")+'</span>';
    box.innerHTML=h;
    box.hidden=false;
  }
  /* Any sums the selected view: the Missed pill or All recorded misses.
     Each uses its own population, including retired records. Summing the
     buckets rather than counting the list again is what keeps that true. */
  function countAllMiss(){
    var t=0,k;
    for(k in MISSN)if(Object.prototype.hasOwnProperty.call(MISSN,k))t+=MISSN[k];
    return t;
  }

  /* AN EMPTY LIST SHOULD ANSWER THE QUESTION THAT EMPTIED IT. "Nobody here
     matches that" is true and useless when the reason is that nobody's
     three weeks is up yet, which is a fact with a date attached. */
  function emptyWords(all){
    if(!all.length)return "The line is empty. Seed it, then this fills.";
    if(wlSearch)return "Nobody on the list matches that search.";
    if(wlFilter==="go"&&isTue())return early()?"Nobody is booked for a Tuesday yet. The next weekday run in your text hours books everyone waiting.":"Nobody is booked for a Tuesday yet. The machine books the Monday before at "+hourWord(D.first_turn_book_hour)+" Pacific.";
    if(wlFilter==="wait"&&isTue())return "Nobody is waiting for a first Tuesday.";
    if(wlFilter==="go"){
      var next=null;
      for(var i=0;i<all.length;i++){
        var r=all[i];
        if(clockOf(r)==="wait"&&r.ready&&(next===null||r.ready<next))next=r.ready;
      }
      return next
        ? "Nobody is ready yet. The first people turn green on "+esc(fmtDay(next))+"."
        : "Nobody is ready to be texted right now.";
    }
    if(wlFilter==="wait")return "Nobody is counting down for the first time. Everyone still on a clock has missed a window, and they are under Missed.";
    /* WAITLIST-18 · THE LAST MISS BUTTON HAS TWO DIFFERENT EMPTIES AND ONLY
       ONE OF THEM IS GOOD NEWS. Nobody retired yet is worth saying plainly.
       A reading door that does not send the retired list is a paste still to
       run, and reading that as "nobody" would be a quiet lie about people who
       are sitting in the database right now. */
    if(wlFilter==="miss"&&missPick===maxMiss()){
      if(!hasRetired())
        return "This list is not switched on yet. The machine retires somebody on their "+ordMiss(maxMiss())+" miss, which takes them out of the line, so they arrive in a list of their own. Run WAITLIST-18 in Supabase and they show up here."+
               (D&&D.inactive?" There are "+Number(D.inactive).toLocaleString()+" of them waiting to be shown.":"");
      return "Nobody has been retired. Everybody who has missed is still in the line.";
    }
    if(wlFilter==="miss"&&missPick)return "Nobody in the line has exactly "+missLabel(missPick)+".";
    if(wlFilter==="miss")return "Nobody has let a buy window run out. Every person in the line is on their first turn.";
    if(wlFilter==="history")return missPick?"Nobody has exactly "+missLabel(missPick)+" recorded in this view.":"No saved misses are recorded. Cooldowns and saved miss counts are separate.";
    if(wlFilter==="off") return "Nobody is holding a live buy link right now.";
    if(wlFilter==="buyers")return "Nobody in the line has bought from you before.";
    if(wlFilter==="unsub") return "Nobody in the line has unsubscribed.";
    if(wlFilter==="handheld")return "You have not paused anybody by hand.";
    if(wlFilter==="oldlist") return "Nobody is waiting on the old list.";
    return "Nobody here matches that.";
  }

  /* ---------- send hours ---------- */
  function hourWord(x){return x===0?"12am":x===24?"12am":x<12?x+"am":x===12?"12pm":(x-12)+"pm"}
  var hoursBuilt=false;
  function buildHourPickers(){
    if(hoursBuilt)return; hoursBuilt=true;
    var a=el("wl-h1"),b=el("wl-h2"),i,o;
    for(i=0;i<=23;i++){o=document.createElement("option");o.value=i;o.textContent=hourWord(i);a.appendChild(o)}
    for(i=1;i<=24;i++){o=document.createElement("option");o.value=i;o.textContent=hourWord(i);b.appendChild(o)}
  }

  /* ═══════════ HOW LONG SOMEBODY WAITS ═══════════
     WAITLIST-19. Jan: "i want to be able to switch the waiting time not just
     through changing the client facing text ... push people from being in
     still waiting to ready now but i can adjust it and change it back to 3
     weeks then people who dont meet the criteria goes back to still waitings,
     or even 4 weeks, or 1 week i want to be able to change the system."

     THE DIAL HAS ALWAYS EXISTED AND NOTHING EVER TURNED IT. joiner_delay_days
     is the number queue_display measures a fresh signup against, and the
     control door has accepted a joiner action since WAITLIST-9. The hub had no
     button for it, so the only wait Jan could change was the SENTENCE on the
     page, and the words and the machine have been free to disagree ever since.

     IT IS A MEASUREMENT, NOT A STAMP, and that is exactly why it reverses.
     Nobody is marked ready and no date is rewritten: the machine asks, every
     day, whether the day they joined plus the wait is behind it. Move the
     number down and people cross the line, move it back up and they cross
     back, as often as he likes.

     ⛔ THE ONE THING THAT DOES NOT COME BACK is a turn the machine already
     opened while the wait was short. That person is holding a live buy link,
     their text is sent, and no dial recalls either. So the panel says how many
     people are about to become reachable BEFORE the press, not after. */
  function waitWord(d){
    d=Number(d);
    if(!isFinite(d)||d<0)return "not set";
    if(d===0)return "No wait";
    if(d%7===0)return (d/7)+((d/7)===1?" week":" weeks");
    return d+(d===1?" day":" days");
  }
  /* TODAY IN THE MACHINE'S OWN TIMEZONE, because that is the day queue_display
     compares a ready date against. Reading the browser's own date instead
     would put the count a day out for anybody working late, which on this
     panel means a number of real people that is quietly wrong. */
  function tzToday(){
    var p2=function(x){x=String(x);return x.length<2?"0"+x:x};
    try{
      var parts=new Intl.DateTimeFormat("en-US",{timeZone:(D&&D.tz)||"America/Los_Angeles",
        year:"numeric",month:"2-digit",day:"2-digit"}).formatToParts(new Date());
      var y="",m="",d="";
      for(var i=0;i<parts.length;i++){
        if(parts[i].type==="year")y=parts[i].value;
        if(parts[i].type==="month")m=parts[i].value;
        if(parts[i].type==="day")d=parts[i].value;
      }
      if(y&&m&&d)return y+"-"+p2(m)+"-"+p2(d);
    }catch(e){}
    var n=new Date();
    return n.getFullYear()+"-"+p2(n.getMonth()+1)+"-"+p2(n.getDate());
  }
  function shiftDay(iso,n){
    var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso||"")); if(!m)return "";
    var d=new Date(Date.UTC(Number(m[1]),Number(m[2])-1,Number(m[3])));
    d.setUTCDate(d.getUTCDate()+Number(n||0));
    var p2=function(x){x=String(x);return x.length<2?"0"+x:x};
    return d.getUTCFullYear()+"-"+p2(d.getUTCMonth()+1)+"-"+p2(d.getUTCDate());
  }
  /* WHO MOVES, COUNTED OFF THE SAME ROWS THE LIST IS DRAWN FROM, so the
     sentence above the list and the list underneath it can never disagree.

     The arithmetic is a subtraction rather than a guess: ready is the day they
     joined plus the wait plus one, so changing the wait by a number of days
     moves that date by exactly the same number, and somebody is ready when it
     lands on today or earlier. That is the same test queue_display makes.

     ONLY THE PEOPLE THIS DIAL GOVERNS. A misser's date comes off their
     cooldown, never off the day they joined, so this number moves none of
     them. It is the same line the Missed group draws, which is why the two
     always agree about who is in Still waiting. */
  function waitMoves(newDays){
    var cur=Number(D&&D.joiner_days), all=(D&&D.top)||[];
    if(!isFinite(cur)||!isFinite(Number(newDays)))return null;
    var delta=Number(newDays)-cur, t=tzToday();
    var up=0,back=0,ready=0,waiting=0,fixed=0;
    for(var i=0;i<all.length;i++){
      var r=all[i], st=clockOf(r);
      /* paused, unsubscribed and anybody holding a live link are not on a
         clock at all, so no wait reaches them */
      if(st!=="go"&&st!=="wait")continue;
      /* no date, no arithmetic. An empty string compares as earlier than every
         real one, so counting a dateless row would quietly call it ready. */
      if(!r.ready)continue;
      if(missOf(r))continue;
      /* made ready by hand, which outranks every date and must not be counted
         as somebody this dial could push back */
      if(r.early){if(st==="go")fixed++;continue}
      var was=(st==="go"), will=(shiftDay(r.ready,delta)<=t);
      if(will)ready++; else waiting++;
      if(will&&!was)up++;
      if(!will&&was)back++;
    }
    return {up:up,back:back,ready:ready+fixed,waiting:waiting,delta:delta,fixed:fixed};
  }

  var WAIT_CHOICES=[0,3,7,10,14,21,28,35,42,56], waitBuilt=false;
  function buildWaitPicker(){
    var sel=el("wl-wait-sel"); if(!sel)return;
    if(!waitBuilt){
      waitBuilt=true;
      for(var i=0;i<WAIT_CHOICES.length;i++){
        var o=document.createElement("option");
        o.value=WAIT_CHOICES[i]; o.textContent=waitWord(WAIT_CHOICES[i]);
        sel.appendChild(o);
      }
    }
    /* a wait set from anywhere else still has to be selectable, or opening the
       picker would silently propose changing a setting he only came to read */
    if(!selectHasValue(sel,D.joiner_days)){
      var c=document.createElement("option");
      c.value=Number(D.joiner_days); c.textContent=waitWord(D.joiner_days);
      sel.appendChild(c);
    }
  }
  /* THE DIAL SWITCHES ITSELF OFF IF THE PAYLOAD DOES NOT CARRY THE SETTING,
     the same rule the pace dial and the legend already follow. A control that
     cannot read what it is about would show "not set" and offer to change a
     number it never saw, which is worse than not being there. */
  function canWait(){var n=Number(D&&D.joiner_days);return isFinite(n)&&n>=0}
  function paintWait(){
    var box=el("wl-wait"); if(!box||!D)return;
    box.style.display=canWait()?"":"none";
    if(!canWait()){paintWaitWhy(true);return}
    buildWaitPicker();
    /* never repaint under his hand while the picker is open, the same rule the
       text hours beside it follows */
    if(box.classList.contains("open"))return;
    el("wl-wait-btn").textContent=waitWord(D.joiner_days);
    el("wl-wait-sel").value=String(Number(D.joiner_days));
    paintWaitWhy(true);
  }
  function paintWaitWhy(hide){
    var p=el("wl-wait-why"); if(!p)return;
    if(hide){p.hidden=true;p.innerHTML="";return}
    var want=Number(el("wl-wait-sel").value), m=waitMoves(want);
    if(!m){p.hidden=true;return}
    var h="";
    if(m.delta===0){
      /* THE UNCHANGED CASE STILL HAS TO SAY WHERE HE IS STANDING. Opening the
         dial on the setting it already has is how he checks the wait, and a
         line that only says "nobody moves" gives him nothing to compare the
         next number against. It never announces a zero, which is R485's rule
         on this panel and reads as noise anywhere. */
      h="<b>"+esc(waitWord(want))+"</b> is what the machine already waits, so nobody moves. Still waiting is <b>"+
        m.waiting.toLocaleString()+"</b> and ready now is <b>"+m.ready.toLocaleString()+"</b>.";
    }else if(m.delta<0){
      h="<b>"+esc(waitWord(want))+"</b> makes <b>"+m.up.toLocaleString()+"</b> more "+
        (m.up===1?"person":"people")+" ready now. Still waiting becomes <b>"+
        m.waiting.toLocaleString()+"</b> and ready now becomes <b>"+m.ready.toLocaleString()+"</b>.";
      if(m.up)h+='<span class="warn">The machine will start texting them at your pace, inside your text hours, up to today\'s limits. A text it has already sent cannot be pulled back.</span>';
    }else{
      h="<b>"+esc(waitWord(want))+"</b> puts <b>"+m.back.toLocaleString()+"</b> "+
        (m.back===1?"person":"people")+" back on the clock. Still waiting becomes <b>"+
        m.waiting.toLocaleString()+"</b> and ready now becomes <b>"+m.ready.toLocaleString()+"</b>.";
    }
    h+='<span class="quiet">This counts the people who signed up and have never missed. A miss puts somebody on the climb back clock instead, which is a separate '+
       esc(waitWord(D.cooldown_days))+' and this dial does not touch it.'+
       (m.fixed?" "+m.fixed.toLocaleString()+" "+(m.fixed===1?"person is":"people are")+" ready by hand and stay ready whatever this says.":"")+
       " Anybody already holding a live buy link keeps it.</span>";
    p.innerHTML=h; p.hidden=false;
  }

  function paint(){
    if(!D)return;
    if(returningQueuePaint)returningQueuePaint();
    var p=el("wl-power");
    if(!confirmArmed){
      p.className="fh-wl-power "+(D.paused?"paused":"running");
      p.textContent=D.paused?"Paused · press to start":"Running · press to pause";
    }
    paintDials();
    paintWait();
    paintTueDials();
    el("fh-wl").classList.toggle("tue",isTue());
    el("wl-tgt").textContent=D.daily_target;
    if(document.activeElement!==el("wl-est"))el("wl-est").value=D.est_wait||"";
    if(isTue()){paintTueChips()}else
    el("wl-chips").innerHTML=
      /* WAITLIST-27 · THE CHIPS THAT MATTER MOST COME FIRST. The grid is four
         across, so the first row holds the goal, the live links, the offers
         opened and the next Monday. Totals follow. */
      chip("Sales today",(D.sales_today||0)+" of "+D.daily_target,
           (D.sales_today||0)>D.daily_target?((D.sales_today-D.daily_target)+" extra sales tracked"):(D.paused?"machine paused":"new offers stop at "+D.daily_target),
           "Purchases counted during today's Pacific waitlist day. Late purchases are still counted after the machine reaches its sales goal.")+
      /* WITH NO CEILING THIS CHIP IS THE EXPOSURE, not a status. Every
         one of these people holds a working buy link, so the words have
         to change with the setting or the most important number on the
         panel reads like a footnote. */
      chip("Active buy links",D.open_now||0,
           "people can buy right now",
           "People whose spot is open right now. They can buy until their 24-hour link expires or they purchase.")+
      chip("Offers opened today",D.offers_today||0,
           D.max_offers_per_day?"of "+D.max_offers_per_day+" daily limit":"no daily limit",
           "People the machine moved into an open spot today. Each opening creates a turn text for Klaviyo. This counts the opening, not confirmation that Klaviyo delivered the text.")+
      (D.mondays&&D.mondays.length?chip("Next Monday",(D.mondays[0].booked||0)+" of "+(D.mondays[0].cap||0),esc(String(D.mondays[0].text||"")),
           "Second chances booked for the next Monday. Each person gets a heads-up the Friday before and their link on Monday."):"")+
      /* WAITLIST-25 · the two promised days. First turns open on Tuesdays and
         second chances on Mondays, so the next of each is the number worth
         watching. Both chips stay away until the database sends the days. */
      (D.tuesdays&&D.tuesdays.length?chip("Next Tuesday",(D.tuesdays[0].booked||0)+" of "+(D.tuesdays[0].cap||0),esc(String(D.tuesdays[0].text||"")),
           "First turns booked for the next Tuesday. The machine books the top of the line the Monday before at "+hourWord(D.first_turn_book_hour)+" and sends each person the heads-up then."):"")+
      chip("Total listed",(D.in_line||0).toLocaleString(),"includes paused and buyers",
           "All listed records, including people excluded from turns. The breakdown below accounts for them.")+
      chip("In cooldown",D.climbing||0,"includes paused people",
           "People with a remaining cooldown, including paused people and previous buyers. This is not the count of one-miss people or people eligible for another turn.")+
      /* WAITLIST-18 · the number of misses is the machine's dial, so this
         chip reads it rather than repeating a 3 that a future press of that
         dial would make wrong. */
      chip("Retired",D.inactive||0,"after the "+ordMiss(maxMiss())+" miss",
           "People removed from the running after missing "+maxMiss()+" buy windows. Press Missed, then the last button, to see who they are.");
    /* only rebuild when the line actually changed, and keep the scroll
       where he left it. Without this the 20 second poll would yank the
       list back to the top mid scroll and disarm hover buttons. */
    paintTop();
    paintFeed(false);
    var tzShort=(D.tz==="America/Los_Angeles")?"Pacific":D.tz;
    paintPlan(tzShort);
    paintHow(tzShort);
    newLoad(false);
    el("wl-note").textContent="Commission-turn messages use the "+hourWord(D.day_start)+" to "+hourWord(D.day_end)+" "+tzShort+" window. Warm-up messages follow their Klaviyo timing. Queue counts refresh every 20 seconds.";

    /* the hours button, unless he is in the middle of changing them */
    if(!el("wl-hours").classList.contains("open")){
      el("wl-hours-btn").textContent=hourWord(D.day_start)+" to "+hourWord(D.day_end)+" "+tzShort;
    }

    /* the three preview doors. Built from the same page_url the turn text
       itself uses, so they can never point somewhere the customer is not
       actually sent. */
    var base=D.page_url||"";
    var peek=[["wl-peek-turn","turn"],["wl-peek-miss","miss"],["wl-peek-wait","wait"]];
    peek.forEach(function(pair){
      var a=el(pair[0]); if(!a)return;
      if(!base){a.style.display="none";return}
      a.style.display="";
      a.href=base+(base.indexOf("?")>-1?"&":"?")+"ffq_admin="+pair[1];
    });
  }

  /* ═══════════ WAITLIST-25 · THE TUESDAY DIALS ═══════════
     Jan: "i want my data hub to integrate seamlessly and see and control
     everything from there but i want it to be clear and simple."

     Five dials, each one a single setting in the database, each one saying
     in words what it does. The four trickle dials hide in Tuesday mode
     because none of them moves anything then: the Monday booking ignores the
     sales goal, the live link limit, the pace and the daily offer brake, and
     the wait after joining is replaced by Days before a first turn. Before
     WAITLIST-25 is installed the payload has no mode, so nothing here shows
     and the panel is exactly what it was. */
  /* the big numbers seat the returning group 150 a Tuesday (plan 2026-09-29);
     the database allows first turns to 500 and old list seats to 200 */
  var FIRST_CAPS=[10,15,20,25,30,35,40,50,60,80,100,150,200,250],
      COLD_SEATS=[0,5,10,15,20,25,30,40,60,80,100,150,200],
      RETURN_CAPS=[50,100,150,200,300,400,500],
      MIN_DAYS=[7,9,10,12,14,21],
      FIRST_PICKS=[0,50,100];
  function canTue(){return !!(D&&typeof D.first_turn_mode==="string")}
  function has38(){return valid38(D)}
  function valid38(s){
    return !!(s&&s.waitlist38_supported===true&&typeof s.cold_fill_all==="boolean"&&
      typeof s.return_all==="boolean"&&typeof s.opening_spread==="boolean");
  }
  function with38(d){
    if(!d||!valid38(W38))return d;
    ["waitlist38_supported","waitlist38_version","cold_fill_all","return_all","opening_spread",
      "opening_spread_threshold","opening_spread_last_minute","first_turn_hour","return_hour","ready_for_seat",
      "stopped_profile_permission","stopped_queue_changed","return_weeks"].forEach(function(k){
      if(Object.prototype.hasOwnProperty.call(W38,k))d[k]=W38[k];
    });
    return d;
  }
  function fillSelect(sel,list,cur,word){
    if(!sel)return;
    var want=list.slice(), c=Number(cur);
    if(isFinite(c)&&want.indexOf(c)<0){want.push(c);want.sort(function(a,b){return a-b})}
    var key=want.join(",");
    if(sel.getAttribute("data-built")!==key){
      sel.innerHTML="";
      for(var i=0;i<want.length;i++){
        var o=document.createElement("option"); o.value=String(want[i]); o.textContent=word(want[i]); sel.appendChild(o);
      }
      sel.setAttribute("data-built",key);
    }
    /* never under his hand while he is choosing */
    if(document.activeElement!==sel&&isFinite(c))sel.value=String(c);
  }
  function show(id,on){var n=el(id);if(n)n.style.display=on?"":"none"}
  function fillSeatSelect(sel,list,cur,all,word){
    fillSelect(sel,list,cur,word);
    if(!sel)return;
    var opt=sel.querySelector('option[value="all"]');
    if(has38()&&!opt){
      opt=document.createElement("option");opt.value="all";opt.textContent="All eligible";sel.appendChild(opt);
    }else if(!has38()&&opt){opt.remove();}
    if(has38()&&all&&document.activeElement!==sel)sel.value="all";
  }
  function paint38Dials(){
    var parent=el("wl-first-cap-wrap")&&el("wl-first-cap-wrap").parentNode;
    if(has38()&&parent&&!el("wl-opening-spread-wrap")){
      var spread=document.createElement("div");
      spread.className="fh-wl-choice fh-wl-tue";spread.id="wl-opening-spread-wrap";
      spread.innerHTML='<span class="lab">Spread large opening days <button type="button" class="fh-wl-info" aria-label="Explain spread large opening days" data-tip="On days with 100 or more people scheduled, newly assigned older-list openings are spread from 10am to 3:50pm Pacific. The count includes people already booked, whose promised times stay unchanged. Normal new sign-ups and smaller day groups use the chosen hour. Later turns keep the group times already assigned. Each person keeps their own full buy window.">?</button></span>'+
        '<button type="button" class="fh-wl-toggle" id="wl-opening-spread" aria-pressed="false">Off</button>';
      parent.appendChild(spread);
      el("wl-opening-spread").addEventListener("click",function(){
        if(!has38())return;
        var on=!D.opening_spread;
        control("opening_spread",on?1:0,null,this,on
          ?"On opening days with 100+ people scheduled, newly assigned older-list openings will be spread across 10am–3:50pm Pacific. Already booked and assigned group times stay unchanged."
          :"New older-list assignments use the chosen fixed hour. Already booked and assigned group times stay unchanged.");
      });
      var hour=document.createElement("div");
      hour.className="fh-wl-choice fh-wl-tue";hour.id="wl-opening-hour-wrap";
      hour.innerHTML='<span class="lab">Chosen opening time <button type="button" class="fh-wl-info" aria-label="Explain chosen opening time" data-tip="Normal new sign-ups use this hour for their first turn. Older-list assignments also use it unless spreading is on and their opening day has 100+ people scheduled in total. That larger group gets assigned times across the day. Choosing an hour does not change the spreading switch, existing bookings or group times already assigned for later turns.">?</button></span>'+
        '<select id="wl-opening-hour" aria-label="Chosen time for new openings"></select>';
      parent.appendChild(hour);
      el("wl-opening-hour").addEventListener("change",function(){
        if(!has38())return;
        var h=parseInt(this.value,10);if(!(h>=10&&h<=15))return;
        control("opening_hour",h,null,this,"Normal new sign-ups and "+(D.opening_spread?"older-list assignments on days below 100 people":"new older-list assignments")+" use "+hourWord(h)+" Pacific. The spreading switch, existing bookings and assigned group times stay unchanged.");
      });
    }
    show("wl-opening-spread-wrap",has38()&&canTue());
    show("wl-opening-hour-wrap",has38()&&canTue());
    if(has38()){
      var hours=[];
      for(var h=10;h<=15;h++)if(h>=Number(D.day_start)&&h<Number(D.day_end))hours.push(h);
      fillSelect(el("wl-opening-hour"),hours,D.first_turn_hour,function(n){return hourWord(n)+" Pacific";});
    }
    var button=el("wl-opening-spread");
    if(button&&has38()){
      button.textContent=D.opening_spread?"On":"Off";
      button.className="fh-wl-toggle"+(D.opening_spread?" on":"");
      button.setAttribute("aria-pressed",String(D.opening_spread));
    }
    var ci=document.querySelector("#wl-cold-wrap .fh-wl-info");
    if(ci)ci.setAttribute("data-tip",has38()
      ?"Choose a weekly number, or All eligible older subscribers. All books everyone who has finished warm-up and passed the current checks, beyond the normal Tuesday seat limit. It also enables All repeat turns and spreading: on opening days with 100+ people scheduled, new older-list assignments are spread across the day. Buyers, unsubscribes and people needing review are excluded. Existing dates and times stay unchanged."
      :"Extra Tuesday seats for older sign-ups, using seats new people leave empty. This does not start warm-up messages. People must finish warm-up and pass the seat checks first.");
    var ri=document.querySelector("#wl-return-cap-wrap .fh-wl-info");
    if(ri)ri.setAttribute("data-tip",has38()
      ?"All eligible keeps the whole eligible group on its next allowed Monday after a miss. A number limits each Monday and moves the overflow to a later week. Existing bookings stay unchanged."
      :"How many repeat turns fit on one Monday. People beyond this number wait for a later Monday. Existing bookings stay unchanged.");
  }
  function paintTueDials(){
    var tue=isTue(), any=canTue();
    /* the trickle dials. Pace, the offer brake and the wait set their own
       display a moment earlier, so this only ever hides them. */
    var tgt=el("wl-tgt"), win=el("wl-win");
    if(tgt&&tgt.closest)tgt.closest(".fh-wl-dial").style.display=tue?"none":"";
    if(win&&win.closest)win.closest(".fh-wl-dial").style.display=tue?"none":"";
    if(tue){show("wl-pace-dial",false);show("wl-offer-limit-wrap",false);show("wl-wait",false);paintWaitWhy(true)}
    show("wl-first-cap-wrap",tue); show("wl-cold-wrap",tue); show("wl-min-days-wrap",tue);
    show("wl-return-cap-wrap",any); show("wl-payday-wrap",any);
    var h26=has26(); show("wl-early-wrap",h26); show("wl-first-pick-wrap",h26);
    if(h26){
      var eb=el("wl-early");
      if(eb){
        var eon=D.first_book_early===true;
        eb.textContent=eon?"On":"Off";
        eb.className="fh-wl-toggle"+(eon?" on":"");
        eb.setAttribute("aria-pressed",String(eon));
      }
      fillSelect(el("wl-first-pick"),FIRST_PICKS,Number(D.first_pick_share)||0,function(n){return n>=100?"Everyone":n>0?"Half":"Off"});
    }
    var fcInfo=document.querySelector("#wl-first-cap-wrap .fh-wl-info");
    if(fcInfo)fcInfo.setAttribute("data-tip",early()
      ?"How many first turns fit each Tuesday. New people are booked in line order on a weekday after they join, after the minimum wait below. Klaviyo sends their booking notice on its own flow timing. Dates already booked stay booked."
      :"How many first turns fit each Tuesday. The machine books them the Monday before, in line order, and hands the reminder to Klaviyo. Dates already booked stay booked.");
    if(tue){
      fillSelect(el("wl-first-cap"),FIRST_CAPS,D.first_turn_cap,function(n){return String(n)});
      fillSeatSelect(el("wl-cold"),COLD_SEATS,D.cold_fill_max,D.cold_fill_all,function(n){return n?String(n):"Off"});
      fillSelect(el("wl-min-days"),MIN_DAYS,D.first_turn_min_days,function(n){return n+(n===1?" day":" days")});
    }
    if(any){
      fillSeatSelect(el("wl-return-cap"),RETURN_CAPS,D.return_cap,D.return_all,function(n){return String(n)});
      var pb=el("wl-payday");
      if(pb){
        var on=!!D.payday_mondays;
        pb.textContent=on?"On":"Off";
        pb.className="fh-wl-toggle"+(on?" on":"");
        pb.setAttribute("aria-pressed",String(on));
      }
    }
    paint38Dials();paintMode();
  }
  /* SWITCHING HOW FIRST TURNS GO OUT asks twice, like Start, because it
     changes who gets texted this week. */
  var modeArmed=false, modeT=null;
  function paintMode(){
    var b=el("wl-mode"); if(!b)return;
    b.hidden=!canTue(); if(b.hidden)return;
    var tue=isTue();
    b.className="fh-wl-mode"+(modeArmed?" arm":"");
    b.textContent=modeArmed
      ? (tue?"Press again to switch first turns back to the old trickle":"Press again to switch first turns to Tuesdays")
      : (tue?"First turns go out on Tuesdays. Switch back to the old trickle":"First turns trickle out all week. Switch to Tuesdays");
  }
  function paintTueChips(){
    var nt=(D.tuesdays&&D.tuesdays[0])||null, nm=(D.mondays&&D.mondays[0])||null, seats=Number(D.cold_fill_max)||0;
    el("wl-chips").innerHTML=
      /* WAITLIST-27 · The next Tuesday and the next Monday lead, then the
         live links and the sales, so the first row of four answers "what
         happens next". Totals follow. */
      (nt?chip("Next Tuesday",(nt.booked||0)+" booked",esc(ymdShort(nt.day))+((nt.old||0)?" · "+(nt.fresh||0)+" new + "+nt.old+" older":""),
           "First turns booked for "+nt.text+". Each person's booked time is shown in their waitlist row. "+(early()?"New people are booked on a weekday after joining, after their minimum wait.":"Booking runs the Monday before at "+hourWord(D.first_turn_book_hour)+" Pacific.")):"")+
      (nm?chip("Next Monday",(nm.booked||0)+" booked",esc(ymdShort(nm.day))+(nm.payday?" · payday":""),
           "Repeat turns booked for "+nm.text+". Each person's booked time is shown in their waitlist row. Their Friday reminder and Monday link go through Klaviyo."):"")+
      chip("Active buy links",D.open_now||0,"people can buy right now",
           "People whose spot is open right now. They can buy until their 24-hour link expires or they purchase.")+
      chip("Sales today",D.sales_today||0,"counted today",
           "Purchases counted during today's Pacific waitlist day.")+
      chip("Turns opened today",D.offers_today||0,"Tuesdays and Mondays",
           "Turn links the machine opened today: first turns on Tuesdays and repeat turns on Mondays. This counts openings, not confirmation that Klaviyo delivered the text.")+
      chip("Total listed",(D.in_line||0).toLocaleString(),"includes paused and buyers",
           "All listed records, including people excluded from turns. The breakdown below accounts for them.")+
      (hasOld()?chip("Older sign-ups",Number(D.cold_left||0).toLocaleString(),has38()&&D.cold_fill_all?"all eligible can be booked":seats?(seats+" extra seats a week"):"extra turn seats off",
           "Older people waiting for commission turns. Warm-up progress is shown separately above. "+(Number(D.cold_seated)||0)+" have received an extra seat so far."):"")+
      chip("Retired",D.inactive||0,"after the "+ordMiss(maxMiss())+" miss",
           "People removed from the running after missing "+maxMiss()+" buy windows. Press Missed, then the last button, to see who they are.");
  }
  function paintTuePlan(box,tzShort){
    var nt=(D.tuesdays&&D.tuesdays[0])||null, nm=(D.mondays&&D.mondays[0])||null;
    var seats=Number(D.cold_fill_max)||0, cap=Number(D.first_turn_cap)||0;
    var book=hourWord(Number(D.first_turn_book_hour)), turnH=hourWord(Number(D.first_turn_hour)), retH=hourWord(Number(D.return_hour));
    var weeks=Array.isArray(D.return_weeks)&&D.return_weeks.length&&D.return_weeks.every(function(n){return typeof n==='number'&&isFinite(n)&&n>0;})
      ?' Waits after each miss are about '+D.return_weeks.join(', ')+' weeks. The next date is booked when the miss happens.':'';
    var lead=(early()
      ? "New sign-ups get a Tuesday booking after at least <b>"+(Number(D.first_turn_min_days)||12)+"</b> days in line. Up to <b>"+cap+"</b> first turns fit each Tuesday. "
      : "Monday at <b>"+book+"</b> "+tzShort+", the machine books up to <b>"+cap+"</b> first turns for Tuesday, new sign-ups first. ")+
      (has38()&&D.cold_fill_all?'<span class="quiet">Older sign-ups: <b>all eligible people</b> can be booked for Tuesday during Monday\'s booking window, beyond the normal seat limit. People who fail the seat checks are excluded.</span>':seats?'<span class="quiet">Older sign-ups: up to <b>'+seats+'</b> eligible people take spare Tuesday seats. Booking runs Monday at <b>'+book+'</b> '+tzShort+'.</span>':'<span class="quiet">Older-list seats are off. This does not turn off messages already scheduled in Klaviyo.</span>')+
      (has38()&&D.opening_spread?'<span class="quiet">On days with <b>'+(Number(D.opening_spread_threshold)||100)+'</b> or more people scheduled, newly assigned older-list openings are spread from <b>10am to 3:50pm Pacific</b>. Normal new sign-ups and smaller day groups use <b>'+turnH+'</b> '+tzShort+'. Already booked people keep their promised time. Later turns keep the group times already assigned.</span>':'<span class="quiet">'+(has38()?'New bookings: first':'First')+' turns open Tuesday at <b>'+turnH+'</b> '+tzShort+'. Repeat turns open on a booked Monday at <b>'+retH+'</b>.'+(has38()?' Already booked people and assigned later turns keep their promised time.':'')+'</span>')+
      '<span class="quiet">After a miss, '+(has38()&&D.return_all?'the whole eligible group can get its next allowed Monday':'up to <b>'+Number(D.return_cap||0)+'</b> repeat turns fit each Monday')+(D.payday_mondays?', after the 1st or the 15th':'')+'.'+weeks+' Each person gets their own full buy window. Current booked dates and times are in the rows below.</span>';
    var next=[];
    if(nt)next.push(nt.booked
      ? "<b>"+nt.booked+"</b> booked for "+esc(nt.text)+((nt.old||0)?" ("+(nt.fresh||0)+" new, "+nt.old+" from the old list)":"")
      : (early()?"Nobody booked for "+esc(nt.text)+" yet":"Nobody booked for "+esc(nt.text)+" yet. Booking opens the Monday before at "+book));
    if(nm)next.push("<b>"+(nm.booked||0)+"</b> second "+((nm.booked||0)===1?"chance":"chances")+" on "+esc(nm.text)+(nm.payday?", a payday Monday":""));
    var today='<span class="quiet">So far today, <b>'+(D.offers_today||0)+'</b> '+((D.offers_today||0)===1?"turn":"turns")+
      ' opened, <b>'+(D.open_now||0)+'</b> holding a live link, <b>'+(D.sales_today||0)+'</b> sold.</span>';
    var nextLine=next.length?'<span class="quiet">'+next.join(". ")+".</span>":"";
    var pending=D.events_pending||0;
    if(D.paused){
      box.className="fh-wl-plan off";
      box.innerHTML="The machine is <b>paused</b>. No bookings, no turns and no texts from the machine until you press start."+
        (pending?'<span class="quiet"><b>'+pending+'</b> already queued '+(pending===1?"message is":"messages are")+' still finishing.</span>':"")+
        '<span class="quiet">Anybody holding a buy link can still buy. Press start and this is what runs. '+lead+"</span>"+nextLine;
      return;
    }
    if(D.closed_now){
      box.className="fh-wl-plan off";
      box.innerHTML="Closed for the weekend. It opens again Monday at "+hourWord(D.day_start)+" "+tzShort+"."+
        '<span class="quiet">'+lead+"</span>"+nextLine+today;
      return;
    }
    box.className="fh-wl-plan";
    box.innerHTML=lead+nextLine+today;
  }

  /* ═══════════ THE PACE, AND WHAT TODAY WILL DO ═══════════
     The plain-language select only offers beats the heartbeat can honestly
     hit. Live-link capacity and pace still travel together through one
     server action, because "no limit" with no pace would invite the whole
     line in one beat. */
  function paceWord(m){
    if(!m)return "off";
    if(m<60)return m+(m===1?" minute":" minutes");
    if(m%60===0)return (m/60)+((m/60)===1?" hour":" hours");
    return Math.floor(m/60)+" hour "+(m%60)+" minutes";
  }
  function winWord(w){return (w===0)?"No limit":String(w)}
  /* HAS THE DATABASE LEARNED THE PACE YET. The theme and the SQL are two
     separate pastes on two separate days, and everything below has to work
     on both sides of that gap. */
  function canPace(){return !!(D&&typeof D.drip_minutes==="number")}
  function canOfferLimit(){return !!(D&&typeof D.max_offers_per_day==="number")}
  function selectHasValue(sel,value){
    if(!sel)return false;
    for(var i=0;i<sel.options.length;i++)if(sel.options[i].value===String(value))return true;
    return false;
  }
  function paintDials(){
    el("wl-win").textContent=winWord(D.open_turns_max);
    var dial=el("wl-pace-dial");
    /* the pace dial hides itself until the database knows the word, because
       a dial that refuses every press is worse than no dial at all */
    if(dial)dial.style.display=canPace()?"":"none";
    var paceSel=el("wl-pace-select");
    if(canPace()&&paceSel){
      if(!selectHasValue(paceSel,D.drip_minutes)){
        var po=document.createElement("option"); po.value=D.drip_minutes;
        po.textContent=paceWord(D.drip_minutes); paceSel.appendChild(po);
      }
      paceSel.value=String(D.drip_minutes);
    }
    var capWrap=el("wl-offer-limit-wrap"), capSel=el("wl-offer-limit");
    if(capWrap)capWrap.style.display=canOfferLimit()?"":"none";
    if(canOfferLimit()&&capSel){
      if(!selectHasValue(capSel,D.max_offers_per_day)){
        var co=document.createElement("option"); co.value=D.max_offers_per_day;
        co.textContent=D.max_offers_per_day||"No limit"; capSel.appendChild(co);
      }
      capSel.value=String(D.max_offers_per_day);
    }
  }
  /* both dials, one call. The partner value is filled in for him when the
     pair he is reaching for would be the forbidden one, and the green note
     says what was filled in, because a dial that silently moves a dial he
     did not touch is worse than an error. */
  function sendPace(w,m,btn){
    /* OLD DATABASE, OLD DOOR. Without WAITLIST-12 there is no pace and no
       such thing as no limit, so the ceiling goes back through the word
       the database already knows and nothing about this dial breaks while
       the SQL is still waiting to be pasted. */
    if(!canPace()){
      control("windows",Math.max(1,Math.min(20,w)),null,btn);
      return;
    }
    var fixed="";
    if(w===0&&m===0){m=15;fixed=" A pace of 15 minutes came on with it, because no limit with no pace would text the whole line at once."}
    control("pace",null,w+"/"+m,btn,
      "Now "+(w===0?"no limit on how many hold a slot":"up to "+w+" people at a time")+
      (m?", one text every "+paceWord(m):", and no pace")+"."+fixed);
  }
  /* WHAT TIME IS IT WHERE THE MACHINE LIVES. Everything below turns on
     this, because "up to 32 texts today" read at 4pm is a lie by a factor
     of eight. The config carries the zone and the server carries the
     moment, so the browser's own clock and zone are never consulted. Any
     browser without Intl falls back to quoting a whole day and says so in
     those words, which is true rather than merely vague. */
  function localHourNow(tz,stamp){
    try{
      var d=stamp?new Date(stamp):new Date();
      if(isNaN(d.getTime()))d=new Date();
      var parts=new Intl.DateTimeFormat("en-US",{timeZone:tz,hour:"numeric",minute:"numeric",hour12:false}).formatToParts(d);
      var h=null,m=0;
      parts.forEach(function(p){
        if(p.type==="hour")h=parseInt(p.value,10);
        if(p.type==="minute")m=parseInt(p.value,10);
      });
      if(h===null||isNaN(h))return null;
      if(h===24)h=0;
      return h+(isNaN(m)?0:m)/60;
    }catch(e){return null}
  }
  function paintPlan(tzShort){
    var box=el("wl-plan"); if(!box)return;
    if(isTue()){paintTuePlan(box,tzShort);return}
    var pace=canPace()?D.drip_minutes:0;
    var w=D.open_turns_max, tgt=D.daily_target;
    var open=D.open_now||0, sent=D.offers_today||0, sold=D.sales_today||0;
    var offerLimit=canOfferLimit()?D.max_offers_per_day:0;
    var pending=D.events_pending||0;
    var ready=(typeof D.ready_now==="number")?D.ready_now:null;
    var winH=Math.max(0,(D.day_end||0)-(D.day_start||0));
    var winHrs=D.window_hours||24;
    var hrs=hourWord(D.day_start)+" and "+hourWord(D.day_end)+" "+tzShort;
    var nowH=localHourNow(D.tz,D.stamp);

    /* SO FAR TODAY is pure fact and cannot be wrong, so it rides under
       every version of the sentence above it. */
    function sofar(){
      var bits=[];
      bits.push("<b>"+sent+"</b> turn "+(sent===1?"offer":"offers")+" opened");
      bits.push("<b>"+open+"</b> holding a live link");
      bits.push("<b>"+sold+"</b> of <b>"+tgt+"</b> sold");
      return '<span class="quiet">So far today, '+bits.join(", ")+".</span>";
    }

    if(D.paused){
      box.className="fh-wl-plan off";
      var pauseLead=pending
        ? "The machine is <b>pausing</b>. It will not create another offer, and <b>"+pending+"</b> already queued "+(pending===1?"message is":"messages are")+" still finishing."
        : "The machine is <b>paused</b>. It will not create another offer until you press start.";
      var pauseBits=[];
      if(D.pending_turns)pauseBits.push(D.pending_turns+" turn "+(D.pending_turns===1?"offer":"offers"));
      if(D.pending_almost_up)pauseBits.push(D.pending_almost_up+" almost-up");
      if(D.pending_missed)pauseBits.push(D.pending_missed+" missed-window");
      if(D.pending_removed)pauseBits.push(D.pending_removed+" removed");
      var startWords="Press start and it will send "+(pace?"one turn offer every <b>"+paceWord(pace)+"</b>":"new turn offers when live buy-link space is open")+
        ", between "+hrs+", until <b>"+tgt+"</b> sales"+
        (offerLimit?" or <b>"+offerLimit+"</b> turn offers, whichever comes first":"")+".";
      box.innerHTML=pauseLead+
        (pauseBits.length?'<span class="quiet">Finishing now: '+pauseBits.join(", ")+".</span>":"")+
        '<span class="quiet">Existing buy links stay live, and any later sale is still counted.</span>'+
        '<span class="quiet">'+startWords+(ready!==null?" "+ready.toLocaleString()+" people are green and ready.":"")+"</span>";
      return;
    }

    if(offerLimit&&sent>=offerLimit){
      box.className="fh-wl-plan off";
      box.innerHTML="Today reached the limit of <b>"+offerLimit+"</b> turn offers. <b>No new buy link opens</b> until the day rolls over at "+hourWord(D.day_start)+" "+tzShort+"."+
        '<span class="quiet">Existing buy links stay live, later sales are still counted, and missed-window or almost-up notices may still finish.</span>'+sofar();
      return;
    }

    /* THE DAY MAY ALREADY BE OVER. The tick's gate is sales_today <
       daily_target in both modes, so once the target lands no new slot
       opens whatever the dials say. It does NOT stop the missed window and
       almost up texts, which run outside that gate, and saying "nothing
       more goes out" while the feed beside it shows one of those going out
       is the kind of small lie that costs trust in the whole panel. */
    if(sold>=tgt){
      box.className="fh-wl-plan off";
      box.innerHTML="<b>"+sold+"</b> "+(sold===1?"person has":"people have")+
        " bought today, so the day is closed. <b>No new slot opens</b> until it rolls over at "+
        hourWord(D.day_start)+" "+tzShort+"."+
        '<span class="quiet">'+
          (open?"<b>"+open+"</b> "+(open===1?"person is":"people are")+" still holding a live buy link from earlier, so more can still come in. ":"")+
          "Missed window and almost up texts are not on this gate and still go out."+
        "</span>";
      return;
    }

    box.className="fh-wl-plan";
    var s;
    if(!pace){
      s="Up to <b>"+w+"</b> "+(w===1?"person holds":"people hold")+" a slot at once, and the machine fills an empty one as soon as it frees up, between "+hrs+
        ". It stops opening new links when <b>"+tgt+"</b> "+(tgt===1?"person buys":"people buy")+
        (offerLimit?" or after <b>"+offerLimit+"</b> turn offers, whichever happens first":"")+".";
      if(w>0&&open>=w)
        s+='<span class="warn">All <b>'+w+'</b> slots are taken right now, so nothing new goes out until one is used or runs out.</span>';
      box.innerHTML=s+sofar();
      return;
    }

    /* ─── how many more can still go out, and what runs out first ───
       Four things can run out and the sentence has to name the one that
       actually does:
         the clock   beats left before the hours close
         the people  how many are green
         the ceiling how many slots are free right now
         the hours   they may already be shut for today
       BEATS, NOT GAPS. The first beat lands as the window opens and every
       pace after it, so eight hours at fifteen minutes is 9:00 through
       16:45, which is 32 beats and 31 gaps. */
    var closed=(nowH!==null&&(nowH>=D.day_end));
    var early =(nowH!==null&&(nowH<D.day_start));
    var minsLeft;
    if(nowH===null)      minsLeft=winH*60;                    /* no clock, quote a whole day */
    else if(closed)      minsLeft=0;
    else if(early)       minsLeft=winH*60;
    else                 minsLeft=Math.max(0,(D.day_end-nowH)*60);
    var beats=minsLeft>0?(Math.floor((minsLeft-1)/pace)+1):0;

    var reach=beats, why="";
    if(nowH===null)      why=", on a full day";
    else if(closed)      why="";
    else if(early)       why=", once the hours open";
    else                 why=", before the hours close today";

    /* THE CEILING IS ONLY THE DAY'S MAXIMUM WHILE A LINK OUTLASTS THE DAY.
       At the default 24 hours it does, so no slot frees up on its own and
       the free slots right now are the whole story. Shorten window_hours
       below the length of the text day and slots turn over inside it, so
       the ceiling stops bounding anything and the clock takes back over. */
    if(w>0&&winHrs>=winH){
      var free=Math.max(0,w-open);
      if(free<reach){reach=free;why=(free===0)
        ?", because every slot is taken right now"
        :", because that is how many slots are free right now";}
    }
    if(ready!==null&&ready<reach){
      reach=ready;
      why=", because that is how many people are green";
    }
    if(offerLimit){
      var offerRoom=Math.max(0,offerLimit-sent);
      if(offerRoom<reach){reach=offerRoom;why=", because that reaches today's turn-offer limit";}
    }

    s="One text every <b>"+paceWord(pace)+"</b> between "+hrs+", "+
      (w===0?"with <b>no limit</b> on how many hold a slot at once"
            :"and never more than <b>"+w+"</b> holding a slot at once")+". ";
    if(closed){
      s+="The hours are shut for today, so nothing more goes out until <b>"+hourWord(D.day_start)+"</b>.";
    }else{
      s+="That is up to <b>"+reach.toLocaleString()+"</b> more turn "+(reach===1?"offer":"offers")+why+
         ". It stops the moment <b>"+tgt+"</b> "+(tgt===1?"person buys":"people buy")+
         (offerLimit?" or today's <b>"+offerLimit+"</b> turn offers are used":"")+".";
    }

    var warn="";
    /* THE ONE THING NO LIMIT REALLY COSTS. The day closes on sales, but a
       person texted an hour before that keeps a working buy link for the
       full window, so the target stops new invitations, not new orders. */
    if(w===0){
      warn+='<span class="warn">Everyone already texted keeps a working buy link for '+
        winHrs+" hours, so more than "+tgt+" can buy on a day that closes early.</span>";
    }
    box.innerHTML=s+warn+sofar();
  }

  /* THE POLL MUST NEVER OUTRANK A HAND. Every twenty seconds this panel
     asks the server for the line again. Two things went wrong with that,
     both of them quiet:

     A stale poll could land after a change and undo it on screen. The
     poll is a heavier query than a control call, so a poll fired at t=0
     can easily answer after a demote fired at t=50ms. Jan sees the row
     jump back to where it was, presses demote again, and the customer
     goes to the back twice. seq is the fix: a load only gets to write D
     if nothing happened while it was in the air.

     And a successful poll wiped the red banner from a change that had
     just FAILED, because it cleared the error unconditionally. Jan would
     have read "removed" on a customer who is still in the line and still
     due a turn text. An error raised by a hand now survives until the
     next hand, or four seconds of being read, whichever comes first. */
  var seq=0, errSticky=false;
  function load38(mine){
    rpc("datahub_waitlist38_status",{p_key:key()}).then(function(s){
      if(mine!==seq)return;
      W38=valid38(s)?s:null;
      if(!D)return;
      ["waitlist38_supported","waitlist38_version","cold_fill_all","return_all","opening_spread",
        "opening_spread_threshold","opening_spread_last_minute","ready_for_seat","stopped_profile_permission","stopped_queue_changed","return_weeks"].forEach(function(k){delete D[k];});
      D=with38(D);paint();
    }).catch(function(){
      if(mine!==seq)return;
      W38=null;
      if(!D)return;
      ["waitlist38_supported","waitlist38_version","cold_fill_all","return_all","opening_spread",
        "opening_spread_threshold","opening_spread_last_minute","ready_for_seat","stopped_profile_permission","stopped_queue_changed","return_weeks"].forEach(function(k){delete D[k];});
      paint();
    });
  }
  function load(done){
    if(!key()||busy){if(done)done();return}
    var mine=seq;
    rpc("datahub_waitlist",{p_key:key()}).then(function(d){
        if(mine!==seq)return;              /* something happened, this answer is stale */
        D=with38(d); if(!errSticky)err(null); paint(); refreshHistory(); fpLoad(false);load38(mine);
      })
      .catch(function(e){
        if(mine!==seq)return;
        err(plainErr(e, "Couldn't reach the waitlist brain."));
      })
      .then(function(){if(done)done()});
  }
  /* Start should feel like a start button, not a note left for the next
     scheduler pass. /queue/ping already exists and runs the same guarded
     tick as Cloudflare's schedule. no-cors lets the request finish without
     exposing any queue data to this page. */
  function wakeQueue(){
    try{
      fetch(QUEUE_URL+"/queue/ping?from=datahub-start",{method:"GET",mode:"no-cors",cache:"no-store"})
        .catch(function(){});
    }catch(e){}
  }
  function control(action,value,text,btn,okMsg){
    if(!key()||busy)return;
    busy=true; seq++; errSticky=false; if(btn)btn.disabled=true;
    var upgraded=has38()&&["cold_fill","return_cap","cold_fill_all","return_all","opening_spread","opening_hour"].indexOf(action)>=0;
    rpc(upgraded?"datahub_waitlist38_control":"datahub_waitlist_control",{p_key:key(),p_action:action,p_value:(value==null?null:value),p_text:(text==null?null:text)})
      .then(function(d){
        if(upgraded)W38=valid38(d)?d:null;
        D=with38(d);err(null);if(okMsg)note(okMsg);paint();
        if(action==="unpause"){
          wakeQueue();
          setTimeout(function(){load()},1800);
        }
      })
      .catch(function(e){
        errSticky=true;
        err(plainErr(e, "That change didn't take, and nothing moved."));
        setTimeout(function(){errSticky=false},20000);
      })
      .then(function(){busy=false;if(btn)btn.disabled=false;paint()});
  }

  /* AN ICON SHOULD NOT BE A MEMORY TEST. Native title text is kept as a
     fallback, while this fixed tooltip appears immediately and cannot be
     clipped by the scrolling list. Focus events make the same explanation
     available without a mouse. */
  var actionTip=document.getElementById("wl-action-tip");
  if(!actionTip){
    actionTip=document.createElement("div"); actionTip.id="wl-action-tip";
    actionTip.className="fh-wl-action-tip"; actionTip.setAttribute("role","tooltip");
    document.body.appendChild(actionTip);
  }
  function showActionTip(b){
    var words=b&&b.getAttribute("data-tip"); if(!words)return;
    actionTip.textContent=words; actionTip.classList.add("show");
    var r=b.getBoundingClientRect(), tw=actionTip.offsetWidth, th=actionTip.offsetHeight;
    var left=Math.max(8,Math.min(window.innerWidth-tw-8,r.left+(r.width-tw)/2));
    var top=r.top-th-7; if(top<8)top=r.bottom+7;
    actionTip.style.left=Math.round(left)+"px"; actionTip.style.top=Math.round(top)+"px";
  }
  function hideActionTip(){actionTip.classList.remove("show")}
  el("wl-top").addEventListener("pointerover",function(evt){
    var b=evt.target&&evt.target.closest?evt.target.closest(".fh-wl-act"):null;
    if(b)showActionTip(b);
  });
  el("wl-top").addEventListener("pointerout",function(evt){
    var b=evt.target&&evt.target.closest?evt.target.closest(".fh-wl-act"):null;
    if(b&&(!evt.relatedTarget||!b.contains(evt.relatedTarget)))hideActionTip();
  });
  el("wl-top").addEventListener("focusin",function(evt){
    var b=evt.target&&evt.target.closest?evt.target.closest(".fh-wl-act"):null;
    if(b)showActionTip(b);
  });
  el("wl-top").addEventListener("focusout",hideActionTip);

  /* Ready Now and Remove both ask twice. One can cause a real turn text on
     the next heartbeat; the other removes a customer. The armed row is not
     repainted for three seconds, so the second press cannot land on a person
     who moved into its place during a poll. */
  function confirmRowAction(b,key,question,restore){
    if(armedKey!==key||!b.classList.contains("arm")){
      var old=el("wl-top").querySelector(".fh-wl-act.arm");
      if(old)old.classList.remove("arm");
      b.classList.add("arm"); b.textContent=question; armedKey=key;
      setTimeout(function(){
        b.classList.remove("arm"); b.innerHTML=restore;
        if(armedKey===key)armedKey=null;
      },3000);
      return false;
    }
    armedKey=null;
    return true;
  }

  /* Hands on the line. Ready changes eligibility but not position. Up/down
     change position but never eligibility. Pause keeps the place, and x is
     the only action that removes the person. */
  el("wl-top").addEventListener("click",function(evt){
    var b=evt.target&&evt.target.closest?evt.target.closest(".fh-wl-act"):null;
    if(!b||busy)return;
    hideActionTip();
    var row=b.closest(".fh-logrow"); if(!row)return;
    var id=Number(row.getAttribute("data-wlid")); if(!id)return;
    var nm=row.getAttribute("data-wlname")||"them";
    var act=b.getAttribute("data-act");
    if(act==="fastpass"){fpPerson(id,nm,b);return}
    if(act==="ready_now"){
      if(!confirmRowAction(b,"ready:"+id,"Ready?","&#10003;"))return;
      control("ready_now",id,null,b,b.getAttribute("data-first")==="1"?nm+" is ready now. The next run moves them to the soonest Tuesday with room. If no sooner Tuesday has room, they keep their booked day.":nm+" is ready now and kept the same position.");
      return;
    }
    if(act==="normal_wait"){
      var wasFront=Number(row.getAttribute("data-zone"))===-1;
      control("normal_wait",id,null,b,nm+" is back on their normal waiting date"+(wasFront?" and at the safe back of the line.":"."));
      return;
    }
    if(act==="promote"){
      control("promote",id,null,b,"Moved "+nm+" to the front of the ready line.");
      return;
    }
    if(act==="demote"){
      control("demote",id,null,b,"Sent "+nm+" to the back of the line.");
      return;
    }
    /* PAUSING IS THE KIND ONE. Removing a past customer throws away their
       place. Pausing keeps it and simply stops the machine from spending
       a turn on them. If it turns out they did want another portrait, one
       press puts them back exactly where they were. The wire word is
       still hold, because renaming it would mean a database change for a
       label nobody but Jan reads. */
    if(act==="hold"){
      control("hold",id,null,b,"Paused "+nm+". They keep their place, no turn will open for them.");
      return;
    }
    if(act==="unhold"){
      control("unhold",id,null,b,(row.getAttribute("data-ol")==="1"&&isTue())
        ? (early()?nm+" is back. The next weekday run books their first Tuesday and texts them the day.":nm+" is back. The next Monday booking gives them the first Tuesday seat their place reaches.")
        : nm+" is back in the running.");
      return;
    }
    if(act==="kick"){
      if(!confirmRowAction(b,"kick:"+id,"Remove?","&times;"))return;
      control("kick",id,null,b,"Removed "+nm+" from the list. They can rejoin any time.");
    }
  });

  /* The feed loads backward only when it is actually read. Reaching the
     bottom fetches one more page; the explicit button repeats that safely
     until the oldest preserved action is on screen. */
  el("wl-feed").addEventListener("scroll",function(){
    var f=el("wl-feed");
    if(historyMode==="newest"&&historyMore&&!historyBusy&&f.scrollHeight-f.scrollTop-f.clientHeight<90){
      loadOlderHistory();
    }
  });
  el("wl-history-first").addEventListener("click",goToFirstAction);

  /* the refresh button pulls fresh numbers right now, no waiting on the 20s cycle */
  el("wl-refresh").addEventListener("click",function(){
    var b=el("wl-refresh");
    if(b.classList.contains("spin"))return;
    b.classList.add("spin");
    var t0=Date.now();
    load(function(){
      setTimeout(function(){b.classList.remove("spin")},Math.max(0,450-(Date.now()-t0)));
    });
  });

  /* start needs a second press, pause never does. Starting texts people. */
  el("wl-power").addEventListener("click",function(){
    if(!D)return;
    var p=el("wl-power");
    if(!D.paused){control("pause",null,null,p);confirmArmed=false;return}
    if(!confirmArmed){
      confirmArmed=true;
      p.className="fh-wl-power confirm";
      p.textContent="Press again to START texting the line";
      clearTimeout(confirmTimer);
      confirmTimer=setTimeout(function(){confirmArmed=false;paint()},5000);
      return;
    }
    confirmArmed=false;clearTimeout(confirmTimer);
    control("unpause",null,null,p);
  });

  /* Help works with a mouse, keyboard, or tap. Only one explanation stays
     open at a time so a phone never fills with overlapping bubbles. */
  el("fh-wl").addEventListener("click",function(evt){
    var b=evt.target&&evt.target.closest?evt.target.closest(".fh-wl-info"):null;
    var all=el("fh-wl").querySelectorAll(".fh-wl-info.open");
    for(var i=0;i<all.length;i++)if(all[i]!==b)all[i].classList.remove("open");
    if(b){evt.preventDefault();b.classList.toggle("open")}
  });
  /* the ceiling climbs 1..20 and then, one more press, off altogether.
     Coming back down from No limit lands on 20, so the trip is reversible
     with the same number of presses it took to get there. */
  el("wl-win-up").addEventListener("click",function(){
    if(!D)return;
    var w=D.open_turns_max, m=canPace()?D.drip_minutes:0;
    if(w===0)return;                       /* already at no limit */
    /* no limit only exists once the database has learned the pace that
       holds it back, so an old database simply stops at 20 */
    if(w>=20){ if(!canPace())return; sendPace(0,m,el("wl-win-up")); return }
    sendPace(w+1,m,el("wl-win-up"));
  });
  el("wl-win-dn").addEventListener("click",function(){
    if(!D)return;
    var w=D.open_turns_max, m=canPace()?D.drip_minutes:0;
    if(w===0){sendPace(20,m,el("wl-win-dn"));return}
    if(w<=1)return;
    sendPace(w-1,m,el("wl-win-dn"));
  });
  el("wl-pace-select").addEventListener("change",function(){
    if(!D||!canPace())return;
    var m=parseInt(this.value,10)||0;
    if(m===0&&D.open_turns_max===0){
      err("Choose a live buy-link limit before turning the pace off. No limit and no pace could invite the whole line at once.");
      this.value=String(D.drip_minutes);
      return;
    }
    sendPace(D.open_turns_max,m,this);
  });
  el("wl-offer-limit").addEventListener("change",function(){
    if(!D||!canOfferLimit())return;
    var n=parseInt(this.value,10)||0;
    control("offerlimit",n,null,this,n?"The machine will stop after "+n+" turn offers today.":"The daily turn-offer limit is off.");
  });
  /* WAITLIST-25 · the Tuesday dials. Each one is one setting and one call,
     and the green note says what happens next in plain words. */
  el("wl-first-cap").addEventListener("change",function(){
    if(!D||!isTue())return;
    var n=parseInt(this.value,10); if(!(n>=1&&n<=500))return;
    control("first_cap",n,null,this,early()?"Up to "+n+" first turns each Tuesday. New bookings follow it right away, and days already booked keep their day.":"Up to "+n+" first turns each Tuesday, starting with the next Monday booking.");
  });
  el("wl-cold").addEventListener("change",function(){
    if(!D||!isTue())return;
    if(this.value==="all"&&has38()){
      control("cold_fill_all",1,null,this,"All eligible older sign-ups can be booked during Monday's booking window. All repeat turns and spreading are also on. Existing bookings keep their promised time.");return;
    }
    var n=parseInt(this.value,10); if(!(n>=0&&n<=200))return;
    control("cold_fill",n,null,this,n
      ? "Up to "+n+" people from the old list each Tuesday, the ones who joined first going first, only in seats new people leave empty. The next Monday booking at "+hourWord(Number(D.first_turn_book_hour))+" sends their heads-up."
      : "Extra old-list seats are off. This does not pause the returning warm-up or its normal return to commission turns.");
  });
  el("wl-return-cap").addEventListener("change",function(){
    if(!D||!canTue())return;
    if(this.value==="all"&&has38()){
      control("return_all",1,null,this,"All eligible repeat turns can fit on their next allowed Monday. Existing bookings keep their date and time.");return;
    }
    var n=parseInt(this.value,10); if(!(n>=1&&n<=500))return;
    control("return_cap",n,null,this,"Up to "+n+" second chances each Monday. Anybody past that waits one more week.");
  });
  el("wl-payday").addEventListener("click",function(){
    if(!D||!canTue())return;
    var on=!D.payday_mondays;
    control("payday",on?1:0,null,this,on
      ? "Payday Mondays are on. From the next miss, a second chance lands on the Monday right after the 1st or the 15th."
      : "Payday Mondays are off. From the next miss, a second chance lands on the Monday closest to its wait.");
  });
  el("wl-min-days").addEventListener("change",function(){
    if(!D||!isTue())return;
    var n=parseInt(this.value,10); if(!(n>=0&&n<=60))return;
    control("first_min_days",n,null,this,"Somebody needs "+n+" days in line before a Tuesday turn.");
  });
  el("wl-early").addEventListener("click",function(){
    if(!D||!has26())return;
    var on=D.first_book_early!==true;
    control("first_early",on?1:0,null,this,on
      ? "Booking at join is on. New people get their Tuesday on the next weekday run, with a text that names the day."
      : "Booking at join is off. New people get their Tuesday the Monday before. Days already booked keep their day.");
  });
  el("wl-first-pick").addEventListener("change",function(){
    if(!D||!has26())return;
    var n=parseInt(this.value,10); if(!(n===0||n===50||n===100))return;
    control("first_pick",n,null,this,n>=100
      ? "Everyone with a booked first turn can move it once from their spot page."
      : n>0 ? "Half the people with a booked first turn can move it once from their spot page."
      : "Nobody sees the move. Days already moved stay moved.");
  });
  el("wl-mode").addEventListener("click",function(){
    if(!D||!canTue())return;
    if(!modeArmed){
      modeArmed=true; paintMode();
      clearTimeout(modeT); modeT=setTimeout(function(){modeArmed=false;paintMode()},5000);
      return;
    }
    modeArmed=false; clearTimeout(modeT);
    var toTue=!isTue();
    control("first_mode",toTue?1:0,null,this,toTue
      ? (D.first_book_early===true?"First turns go out on Tuesdays again. The next weekday run in your text hours books them.":"First turns go out on Tuesdays again. The next Monday booking picks them.")
      : "First turns trickle out all week again, with the dials you see now.");
  });
  el("wl-tgt-up").addEventListener("click",function(){if(D)control("target",Math.min(50,(D.daily_target||2)+1))});
  el("wl-tgt-dn").addEventListener("click",function(){if(D)control("target",Math.max(1,(D.daily_target||2)-1))});
  el("wl-est-save").addEventListener("click",function(){
    var v=(el("wl-est").value||"").trim();
    if(!v){err("Type the estimate first, like 3 to 4 weeks.");return}
    control("estwait",null,v,el("wl-est-save"));
  });
  el("wl-est").addEventListener("keydown",function(e){if(e.key==="Enter")el("wl-est-save").click()});

  /* ---------- send hours ----------
     BOTH ENDS TRAVEL TOGETHER. Setting them one at a time refuses itself:
     moving 9-to-5pm up to 6pm-to-10pm sends start=18 while the end is
     still 17, and the guard in the database correctly rejects that. So
     the hub sends "18-22" as one string and the database writes the pair
     in one statement. */
  el("wl-hours-btn").addEventListener("click",function(){
    if(!D)return;
    buildHourPickers();
    el("wl-h1").value=String(D.day_start);
    el("wl-h2").value=String(D.day_end);
    el("wl-hours").classList.add("open");
    el("wl-h1").focus();
  });

  /* WAITLIST-19 · the wait, opened, previewed, saved or dropped. Opening it
     shows the answer for the setting it already has, which is "nobody moves",
     so the shape of the sentence is familiar before it ever carries a number
     he has to act on. */
  el("wl-wait-btn").addEventListener("click",function(){
    if(!D)return;
    buildWaitPicker();
    el("wl-wait-sel").value=String(Number(D.joiner_days));
    el("wl-wait").classList.add("open");
    paintWaitWhy(false);
    el("wl-wait-sel").focus();
  });
  el("wl-wait-sel").addEventListener("change",function(){paintWaitWhy(false)});
  el("wl-wait-cancel").addEventListener("click",function(){
    el("wl-wait").classList.remove("open");
    paintWaitWhy(true);
    paintWait();
  });
  el("wl-wait-save").addEventListener("click",function(){
    if(!D||busy)return;
    var want=Number(el("wl-wait-sel").value);
    /* the same range the control door enforces, said here so a refusal is a
       sentence rather than a round trip */
    if(!isFinite(want)||want<0||want>120){err("Pick a wait between no wait and 120 days.");return}
    var m=waitMoves(want);
    el("wl-wait").classList.remove("open");
    paintWaitWhy(true);
    var words="The wait is "+waitWord(want)+" now.";
    if(m&&m.up)words+=" "+m.up.toLocaleString()+" "+(m.up===1?"person":"people")+" just became ready.";
    if(m&&m.back)words+=" "+m.back.toLocaleString()+" "+(m.back===1?"person":"people")+" went back on the clock.";
    /* THE WORDS ON THE PAGE ARE THE OTHER HALF OF THIS FACT and nothing keeps
       them in step, so the one moment he is guaranteed to be thinking about
       the wait is the moment to mention what a visitor is still being told. */
    if(D.est_wait)words+=" The page still says “"+D.est_wait+"”.";
    control("joiner",want,null,el("wl-wait-save"),words);
  });
  el("wl-hours-cancel").addEventListener("click",function(){
    el("wl-hours").classList.remove("open"); paint();
  });
  el("wl-hours-save").addEventListener("click",function(){
    var a=Number(el("wl-h1").value), b=Number(el("wl-h2").value);
    if(!(b>a)){err("The last hour has to be after the first one.");return}
    var tzShort=(D&&D.tz==="America/Los_Angeles")?"Pacific":(D&&D.tz)||"";
    control("hours",null,a+"-"+b,el("wl-hours-save"),
      "Texts now go out between "+hourWord(a)+" and "+hourWord(b)+" "+tzShort+".");
    el("wl-hours").classList.remove("open");
  });

  /* ---------- finding one person ---------- */
  var searchT=null;
  el("wl-search").addEventListener("input",function(){
    var v=(this.value||"").trim().toLowerCase();
    clearTimeout(searchT);
    /* redrawing 800 rows on every keystroke is the one thing here that
       could feel slow, so it waits for a pause in the typing */
    searchT=setTimeout(function(){wlSearch=v;paintTop()},120);
  });
  el("wl-legend").addEventListener("click",function(evt){
    var b=evt.target&&evt.target.closest?evt.target.closest("button[data-f]"):null;
    if(!b)return;
    var f=b.getAttribute("data-f");
    /* pressing the lit one lets go, so there is always a way back to
       everyone without hunting for the tab that does it */
    wlFilter=(wlFilter===f)?"all":f;
    /* WAITLIST-18 · the miss buttons belong to the Missed pill and go out
       with it. Leaving 2 misses pressed while he walks to another group and
       back would show him a narrowed list he never asked for and has no
       reason to suspect. */
    missPick=0;
    /* the arm belongs to a row in the list he was looking at. Changing what
       the list shows takes that row away, so the arm goes with it rather
       than freezing the repaint for the rest of its three seconds. */
    armedKey=null;
    disarmClean();
    paintTop(true);
  });
  /* WAITLIST-18 · the miss buttons. The row is rebuilt on every paint, so the
     listener sits on the container that survives, never on the buttons. */
  el("wl-sub").addEventListener("click",function(evt){
    var b=evt.target&&evt.target.closest?evt.target.closest("button[data-m]"):null;
    if(!b)return;
    var m=Number(b.getAttribute("data-m"))||0;
    /* pressing the lit one lets go, the same gesture the legend above uses */
    missPick=(missPick===m)?0:m;
    armedKey=null;
    disarmClean();
    paintTop(true);
  });
  el("wl-filter").addEventListener("click",function(evt){
    var b=evt.target&&evt.target.closest?evt.target.closest("button[data-f]"):null;
    if(!b)return;
    wlFilter=b.getAttribute("data-f");
    missPick=0;
    /* an arm belongs to the tab it was pressed on. Carrying it across
       would let two presses on two different tabs remove a group he
       never looked at. */
    armedKey=null;
    disarmClean();
    paintTop(true);
  });

  /* The returning group has its own guarded start. Preparing never sends. */
  (function returningWarmup(){
    var host=el('fh-wl');if(!host)return;
    var panel=document.createElement('section');
    panel.className='fh-wl-sec fh-wl-returning';panel.id='wl-returning';
    panel.setAttribute('aria-labelledby','wl-returning-title');
    panel.setAttribute('tabindex','-1');
    panel.innerHTML='<h3 class="fh-wl-h" id="wl-returning-title">Returning warm-up</h3>'+
      '<p class="fh-wl-help">Older sign-ups get a short warm-up before their first commission turn.</p>'+
      '<p class="fh-wl-returning-scope" id="wl-returning-scope">Reading the waitlist and returning group counts...</p>'+
      '<div class="fh-wl-returning-statusrow"><p id="wl-returning-status" role="status" aria-live="polite">Checking warm-up...</p>'+
      '<button type="button" id="wl-returning-check">Refresh status</button></div>'+
      '<div id="wl-returning-counts" class="fh-wl-returning-counts" hidden>'+
      '<ol class="fh-wl-returning-steps">'+
      '<li><span class="fh-wl-returning-step">1 · Before messages</span><b id="wl-rw-prepared">&middot;</b><strong>Waiting to start</strong><p>Prepared in the Hub. Not yet added to the Klaviyo flow.</p></li>'+
      '<li class="fh-wl-returning-current"><span class="fh-wl-returning-step">2 · Before a turn</span><b id="wl-rw-warming">&middot;</b><strong>Not booked yet</strong><p>Messages may still be running, or finished while they wait for a seat.</p></li>'+
      '<li><span class="fh-wl-returning-step">3 · Commission turns</span><b id="wl-rw-returned">&middot;</b><strong>Booked into turns</strong><p>A turn was booked after warm-up. Current dates are below.</p></li></ol>'+
      '<p class="fh-wl-help" id="wl-rw-ready" hidden></p>'+
      '<p class="fh-wl-returning-stopped"><strong><span id="wl-rw-stopped">&middot;</span> stopped this warm-up route</strong><span id="wl-rw-stopped-why">Checks include profile, SMS permission and queue status. Some may already be in the regular queue. These people were not deleted, and are not all unsubscribes.</span></p></div>'+
      '<div class="fh-wl-returning-next"><strong>What happens next</strong><p id="wl-returning-next">Waiting for the latest status.</p></div>'+
      '<div class="fh-wl-returning-delivery"><div><strong>Did the messages arrive?</strong><p>Klaviyo shows delivered messages, failures, opens and clicks. Someone can receive both email and SMS, so those totals are not separate people.</p></div>'+
      '<a href="https://www.klaviyo.com/flow/Yfp28M/edit" target="_blank" rel="noopener">Check deliveries in Klaviyo <span aria-hidden="true">↗</span></a></div>'+
      '<p class="fh-wl-returning-stamp" id="wl-returning-stamp">Waiting for a fresh status check.</p>'+
      '<details class="fh-wl-returning-manage"><summary>Manage this warm-up</summary>'+
      '<p class="fh-wl-help" id="wl-returning-can-prepare">Checking who can be prepared.</p>'+
      '<div class="fh-wl-returning-actions">'+
      '<button type="button" id="wl-returning-prepare" disabled>Prepare paused people</button>'+
      '<button type="button" id="wl-returning-start" disabled>Start warm-up</button>'+
      '<button type="button" id="wl-returning-pause" disabled>Stop new starts</button></div>'+
      '<p class="fh-wl-help">Preparing does not send anything. Starting requires the message checks to pass. Stop new starts prevents new people entering the warm-up. People already receiving it can finish. It does not cancel messages scheduled in Klaviyo.</p>'+
      '<p class="fh-wl-help">People need six days in warm-up and confirmation it finished, then an older-list seat. The setting below controls how many can return each week. New sign-ups keep their normal wait. Buyers and people who unsubscribe are excluded. After five missed turns, the person leaves the active SMS queue.</p>'+
      '<p class="fh-wl-help" id="wl-returning-connection"></p></details>';
    /* HUB-03: folded at the bottom of the panel (it changes rarely); an older page without the fold keeps it on top */
    var warmFold=el('wl-fold-warm');
    if(warmFold)warmFold.appendChild(panel);else host.insertBefore(panel,host.querySelector('.fh-wl-sec-now'));
    var working=false,armedUntil=0,last=null,lastRead=null,readFailed=false;
    function count(n){return Math.max(0,Number(n)||0);}
    function number(n){return count(n).toLocaleString();}
    function time(iso){if(!iso)return 'not available';var d=new Date(iso);return isNaN(d.getTime())?'unknown':d.toLocaleString(undefined,{month:'short',day:'numeric',hour:'numeric',minute:'2-digit'});}
    returningQueuePaint=function(){
      var c=last&&last.counts,total=c?count(c.prepared)+count(c.warming)+count(c.returned)+count(c.stopped):null;
      el('wl-returning-scope').innerHTML=(D&&D.in_line!=null?'<span><b>'+number(D.in_line)+'</b> on the whole waitlist</span>':'<span>Whole waitlist count is loading</span>')+
        (total==null?'':'<span><b>'+number(total)+'</b> in the returning group</span>')+
        '<small>These counts describe different groups. Do not add them together.</small>';
      var readyCount=has38()&&typeof D.ready_for_seat==='number'?count(D.ready_for_seat):null;
      el('wl-rw-ready').hidden=readyCount===null;
      if(readyCount!==null)el('wl-rw-ready').textContent=number(readyCount)+' older sign-ups have finished warm-up and passed the current seat checks.';
      el('wl-rw-stopped-why').textContent=has38()&&typeof D.stopped_profile_permission==='number'&&typeof D.stopped_queue_changed==='number'
        ?number(D.stopped_profile_permission)+' profile or SMS permission checks; '+number(D.stopped_queue_changed)+' queue status changes. These people were not deleted. Some may already be in the regular queue. This is not an unsubscribe count.'
        :'Checks include profile, SMS permission and queue status. Some may already be in the regular queue. These people were not deleted, and are not all unsubscribes.';
    };
    function draw(s){
      last=s;var c=s.counts||{};
      var checked=Date.parse(s.checked_at),fresh=isFinite(checked)&&Date.now()-checked<15*60000;
      var ready=s.flow_ready&&s.five_turns_installed&&fresh;
      panel.dataset.state=readFailed?'unknown':(!s.enabled?'paused':(ready?'running':'attention'));
      el('wl-returning-status').textContent=readFailed?'Could not refresh warm-up':(!s.enabled?'New warm-up starts are off':(ready?'Warm-up is on':'Warm-up needs a connection check'));
      el('wl-returning-counts').hidden=false;
      ['prepared','warming','returned','stopped'].forEach(function(k){el('wl-rw-'+k).textContent=number(c[k]);});
      var next=readFailed?'The counts shown here are from the last successful refresh. Refresh again before changing anything.':
        !s.enabled?(count(c.warming)?'New warm-up starts are off. People already in it can finish. Ready people can still get a Monday booking for Tuesday, if commission openings and older-list seats are on.':'New warm-up starts are off. Use Manage this warm-up when you want to start more people.'):
        !ready?'The connection checks need to pass before new people can enter or return to turns. Messages already scheduled in Klaviyo may still run.':
        count(c.warming)?'Do not restart these people. After warm-up finishes, eligible people wait for an older-list seat. Their commission link opens on their booked Tuesday.':
        count(c.prepared)?'Prepared people will enter automatically as their checks pass. Klaviyo then follows the timing set in the warm-up flow.':
        'Nobody is waiting to enter or finish this warm-up. Current commission dates are shown below.';
      el('wl-returning-next').textContent=next;
      el('wl-returning-stamp').textContent=(readFailed?'Last successful refresh ':'Counts refreshed ')+time(lastRead)+'. Refreshes every minute while this panel is visible.';
      el('wl-returning-can-prepare').textContent=number(s.can_prepare)+' more paused people can be prepared. Preparing only adds them to the waiting stage.';
      el('wl-returning-connection').textContent='Message connection checked '+time(s.checked_at)+'. '+(s.check_note||'No check details available.');
      el('wl-returning-check').disabled=working;
      el('wl-returning-prepare').disabled=working||readFailed||!s.can_prepare;
      el('wl-returning-start').disabled=working||readFailed||s.enabled||!ready||!(c.prepared||c.warming);
      el('wl-returning-pause').disabled=working||readFailed||!s.enabled;
      el('wl-returning-start').textContent=Date.now()<armedUntil?'Confirm start':'Start warm-up';
      returningQueuePaint();
    }
    function run(action){
      if(working||!key())return;working=true;el('wl-returning-check').disabled=true;if(last)draw(last);
      rpc('datahub_waitlist_rewarm',{p_key:key(),p_action:action}).then(function(s){
        if(!s||typeof s.enabled!=='boolean'||!s.counts)throw new Error('Missing returning status');
        working=false;readFailed=false;lastRead=new Date().toISOString();draw(s);
      }).catch(function(){
        working=false;readFailed=true;el('wl-returning-check').disabled=false;
        if(last)draw(last);
        else{
          panel.dataset.state='unknown';
          el('wl-returning-status').textContent='Warm-up status is unavailable';
          el('wl-returning-next').textContent='We could not load this group. That does not mean its messages are off. Refresh here or check Klaviyo directly.';
          el('wl-returning-stamp').textContent='No current warm-up counts were loaded.';
        }
      });
    }
    el('wl-returning-check').addEventListener('click',function(){run('status');});
    el('wl-returning-prepare').addEventListener('click',function(){run('prepare');});
    el('wl-returning-pause').addEventListener('click',function(){run('pause');});
    el('wl-returning-start').addEventListener('click',function(){
      if(Date.now()>=armedUntil){armedUntil=Date.now()+6000;draw(last);setTimeout(function(){if(last)draw(last);},6100);return;}
      armedUntil=0;run('start');
    });
    if(key())run('status');
    setInterval(function(){if(document.visibilityState==='visible'&&host.offsetParent!==null)run('status');},60000);
  })();

  /* ═══════════ FAST PASSES · WAITLIST-34 ═══════════
     For somebody who writes in ready to buy. The ticket button on their row
     (or a first name, for somebody not on the list yet) makes their personal
     link and copies it. The page plays the line skip and opens their spot on
     that page only. Nobody in the line moves and no text goes out. This part
     stays hidden until sql/WAITLIST-34-FAST-PASS.sql answers, so pushing the
     theme first changes nothing. */
  var FP_URL="https://framedfantasy.com/pages/fast-pass";
  var FP_SIZE={half:"Half-Body",thigh:"Thigh-Up",full:"Full-Body"};
  function fpLink(code){return FP_URL+"?pass="+encodeURIComponent(code)}
  function fpCopy(text,okMsg){
    function fallback(){try{window.prompt("Copy this link",text)}catch(e){}}
    try{
      if(navigator.clipboard&&navigator.clipboard.writeText){
        navigator.clipboard.writeText(text).then(function(){note(okMsg)},function(){fallback()});
        return;
      }
    }catch(e){}
    fallback();
  }
  /* "Thu, Oct 8, 9:41 PM" in the hub's own time, for an earned pass's open and end */
  function fpWhen(iso){var t=Date.parse(iso||"");if(!isFinite(t))return"";try{return new Date(t).toLocaleString("en-US",{weekday:"short",month:"short",day:"numeric",hour:"numeric",minute:"2-digit"})}catch(e){return new Date(t).toString()}}
  function fpState(p){
    if(p.off)return{k:"off",w:"Turned off"};
    if(p.bought_at)return{k:"sold",w:"Bought"+(p.order?" "+p.order:"")};
    if(p.checkout_at)return{k:"checkout",w:"Went to checkout"+(p.size&&FP_SIZE[p.size]?", "+FP_SIZE[p.size]:"")};
    /* QUEST-SKIP-01 · a line skip earned in the portal waits 12 hours, then holds for 48 */
    if(p.kind==="earned"){
      var now=Date.now(),o=Date.parse(p.opens_at||""),e=Date.parse(p.ends_at||"");
      if(isFinite(e)&&now>=e)return{k:"ended",w:"Ended"};
      if(isFinite(o)&&now<o)return{k:"new",w:"Opens "+fpWhen(p.opens_at)};
    }
    if(p.opened_at)return{k:"opened",w:"Opened"};
    return{k:"new",w:"Not opened yet"};
  }
  function fpChip(p){
    var s=fpState(p);
    var label={sold:"PASS SOLD",checkout:"PASS CHECKOUT",opened:"PASS OPENED",new:"FAST PASS"}[s.k]||"FAST PASS";
    var tip="Fast pass made "+ago(p.made_at)+(p.opened_at?", opened "+ago(p.last_opened_at||p.opened_at):", not opened yet")+(p.checkout_at?", went to checkout "+ago(p.checkout_at):"")+(p.bought_at?", bought "+ago(p.bought_at):"")+".";
    return '<span class="fh-wl-fpchip is-'+s.k+'" title="'+esc(tip)+'">'+label+'</span>';
  }
  var FP_ICON='<svg viewBox="0 0 20 20" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v1.6a2 2 0 0 0 0 3.8v1.6a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-1.6a2 2 0 0 0 0-3.8z"/><path d="M12.5 5.8v8.4" stroke-dasharray="1.6 1.6"/></svg>';
  function fpOff(why){
    var was=FP.ready; FP.ready=false;
    var off=el("wl-fp-off"),tools=el("wl-fp-tools");
    if(off){off.hidden=false;off.textContent=why==="key"?"Fast passes need the hub's access word.":"Fast passes switch on once sql/WAITLIST-34-FAST-PASS.sql has been run in Supabase."}
    if(tools)tools.hidden=true;
    if(was&&D&&!armedKey)paintTop(true);
  }
  function fpLoad(force){
    if(!key()||!el("wl-fp"))return;
    if(!force&&Date.now()-FP.loadedAt<55000)return;
    FP.loadedAt=Date.now();
    rpc("datahub_fastpass",{p_key:key()}).then(function(d){
      if(!d||d.ok===false){fpOff(d&&d.error==="bad key"?"key":"missing");return}
      var was=FP.ready;
      FP.ready=true; FP.list=d.passes||[]; FP.counts=d.counts||null; FP.byRow={};
      FP.list.forEach(function(p){if(p.queue_id&&!p.off&&!FP.byRow[p.queue_id])FP.byRow[p.queue_id]=p});
      el("wl-fp-off").hidden=true; el("wl-fp-tools").hidden=false;
      fpPaint();
      if(D&&!armedKey)paintTop(true);
      if(!was&&D)paint();
    }).catch(function(){fpOff("missing")});
  }
  function fpPaint(){
    var c=FP.counts||{},box=el("wl-fp-list"),cnt=el("wl-fp-counts");
    var kinds=[["passes","Passes"],["opened","Opened"],["joined","Joined the waitlist through one"],["checkout","Went to checkout"],["bought","Bought"]];
    /* the commission portal's line skip, once sql/QUEST-SKIP-01 sends these */
    if(c.skip_started!=null)kinds.push(["skip_started","Started earning a line skip"]);
    if(c.skip_earned!=null)kinds.push(["skip_earned","Earned in the portal"]);
    if(cnt)cnt.innerHTML=FP.list.length||c.skip_started?kinds.map(function(x){
      return '<span class="fh-fp-count'+(x[0]==="bought"&&c.bought?" is-sold":"")+'"><b>'+(Number(c[x[0]])||0).toLocaleString()+'</b> '+x[1]+'</span>';
    }).join(""):"";
    if(!box)return;
    if(!FP.list.length){box.innerHTML='<div class="fh-wl-empty">No fast passes yet. Press the ticket on somebody\'s row, or type a first name above.</div>';return}
    var rows=FP.list.slice(0,FP.shown).map(function(p){
      var s=fpState(p),bits=[],E=p.kind==="earned",more="";
      bits.push(E?"Earned in the portal":p.kind==="link"?"came through the plain link":p.kind==="name"?"made for a first name":"made from the waitlist");
      if(E&&p.signed)bits.push("signed "+p.signed);
      if(E&&p.size&&FP_SIZE[p.size])bits.push(FP_SIZE[p.size]);
      bits.push((E?"earned ":"made ")+ago(p.made_at));
      if(E&&p.opens_at)bits.push("opens "+fpWhen(p.opens_at));
      if(E&&p.ends_at)bits.push("ends "+fpWhen(p.ends_at));
      if(p.opened_at)bits.push("opened "+ago(p.last_opened_at||p.opened_at)+(p.opens>1?" ("+p.opens+" times)":""));
      if(p.joined)bits.push("joined the waitlist through it");
      if(p.checkouts>1)bits.push(p.checkouts+" checkout presses");
      /* the picks for the painting (the blueprint's own since 2026-10-08), then the step's words, as text: a blueprint
         check from the Fast Pass page ("Checked the blueprint ..."), or on older passes who sees the hero first
         (2026-10-08 night) or a table detail (before that) */
      var pl=E&&p.plan&&typeof p.plan==="object"?p.plan:null,picks=[];
      if(pl){[["pose","Pose"],["vibe","Mood"],["bg","Background"]].forEach(function(x){var v=String(pl[x[0]]==null?"":pl[x[0]]).trim();if(v)picks.push(x[1]+": "+v)})}
      if(picks.length)more+='<span class="fh-fp-meta fh-fp-plan" style="white-space:normal;color:#cfc6b6">'+esc(picks.join(" · "))+'</span>';
      if(E&&p.detail)more+='<span class="fh-fp-meta fh-fp-detail" style="white-space:normal;color:#cfc6b6;font-style:italic">'+(/^Checked the blueprint/.test(String(p.detail))?"Blueprint check":Date.parse(p.made_at)>=Date.parse("2026-10-09T01:30:00Z")?"First to see":"Only their table knows")+': “'+esc(p.detail)+'”</span>';
      /* why they want the portrait now, the send step's question (sql/QUEST-SKIP-04 sends it; empty before that) */
      if(E&&p.why&&String(p.why).trim())more+='<span class="fh-fp-meta fh-fp-why" style="white-space:normal;color:#e9dcc0">Why now: “'+esc(String(p.why).trim())+'”</span>';
      return '<div class="fh-fp-row'+(p.off?" is-off":"")+'" data-code="'+esc(p.code)+'">'+
        '<span class="fh-fp-who"><b>'+esc((E&&p.hero_name)||p.name||"Somebody")+'</b><span class="fh-fp-meta"'+(E?' title="'+esc(bits.join(" · "))+'"':'')+'>'+esc(bits.join(" · "))+'</span>'+more+'</span>'+
        '<span class="fh-fp-state is-'+s.k+'">'+esc(s.w)+'</span>'+
        '<span class="fh-fp-acts">'+(p.off?'':'<button type="button" data-fp="copy">Copy link</button>')+
        '<button type="button" data-fp="'+(p.off?"on":"off")+'">'+(p.off?"Turn back on":"Turn off")+'</button></span></div>';
    }).join("");
    if(FP.list.length>FP.shown)rows+='<button type="button" class="fh-fp-more" data-fp="more">Show '+Math.min(30,FP.list.length-FP.shown)+' more</button>';
    box.innerHTML=rows;
  }
  /* ═══════════ HUB-03 · HOW THE WAITLIST WORKS, IN SIX LINES ═══════════
     Jan, 2026-10-10: "basically just tell me simply like im 12 trace the steps". Every number is the machine's own
     setting, so the lines stay true when a dial moves. */
  function paintHow(tzShort){
    var box=el("wl-how-steps");if(!box||!D)return;
    var hr=function(h){return hourWord(Number(h)||0)+" "+tzShort},weeks=(D.return_weeks||[]).filter(function(w){return Number(w)>0});
    var max=maxMiss(),win=Number(D.window_hours)||24,lines=[];
    if(isTue()){
      lines.push("Someone joins the line on the D&amp;D product page, with a phone number in the Quest, or on their Fast Pass page.");
      lines.push("Their first turn is booked for the first <b>Tuesday</b> at least <b>"+(Number(D.first_turn_min_days)||10)+" days</b> away, at <b>"+hr(D.first_turn_hour)+"</b>.");
      lines.push("Before the day they get a heads-up text. On the day they get a text with a private buy link. It works for <b>"+win+" hours</b>.");
      lines.push("If they buy, that is a sale and they leave the line.");
      lines.push("If the link runs out, they get another chance on a <b>Monday</b> at <b>"+hr(D.return_hour)+"</b>"+(weeks.length?", <b>"+weeks.join(", ")+" weeks</b> later in turn":"")+". <b>"+max+" chances</b> in all, then they leave the line.");
      lines.push((D.weekends_off?"Nothing opens from Friday "+hr(D.friday_close_hour)+" to Monday "+hr(D.day_start)+". ":"")+"So turn sales come in from <b>Monday afternoon to Wednesday afternoon</b>. Fast Pass holders and repeat customers can buy any day.");
    }else{
      lines.push("Someone joins the line, and waits their turn in the order they joined.");
      lines.push("Turns open every day between "+hr(D.day_start)+" and "+hr(D.day_end)+", until the day's sales goal.");
      lines.push("A turn is a text with a private buy link. It works for <b>"+win+" hours</b>.");
      lines.push("If the link runs out they drop back and climb again. <b>"+max+" chances</b> in all.");
    }
    var h=lines.map(function(t){return "<li>"+t+"</li>"}).join("");
    if(box.innerHTML!==h)box.innerHTML=h;
  }

  /* ═══════════ HUB-03 · NEW SIGN-UPS, AND WHERE THEY JOINED ═══════════
     Jan, 2026-10-10, about the D&D product page's waitlist box: "when someone signs up there i want to be able to see
     it in the data hub as well". datahub_waitlist_signups (sql/HUB-03) answers; the page each join came from is told
     by the box itself since HUB-03, so older joins read "Waitlist box" (product page or /pages/waitlist). */
  var NEW={ready:false,missing:false,loadedAt:0,d:7,h:0,data:null,shown:12,busy:false};
  var NEW_WHERE=[["product","D&D product page"],["waitlist_page","Waitlist page"],["fast_pass","Earn page"],["quest","Quest phone number"],["list","Klaviyo waitlist list"],["box","Waitlist box, page not recorded"]];
  function newWord(k){for(var i=0;i<NEW_WHERE.length;i++)if(NEW_WHERE[i][0]===k)return NEW_WHERE[i][1];return "Elsewhere"}
  function newLoad(force){
    if(!key()||!el("wl-new")||NEW.busy)return;
    if(!force&&Date.now()-NEW.loadedAt<60000)return;
    NEW.loadedAt=Date.now();NEW.busy=true;
    rpc("datahub_waitlist_signups",{p_key:key(),p_days:NEW.d,p_hours:NEW.h}).then(function(d){
      NEW.busy=false;
      if(!d||d.ok===false){newOff(d&&d.error==="bad key"?"key":"missing");return}
      NEW.ready=true;NEW.missing=false;NEW.data=d;newPaint();
    }).catch(function(){NEW.busy=false;newOff("missing")});
  }
  function newOff(why){
    NEW.missing=true;
    var w=el("wl-new-where"),l=el("wl-new-list");if(l)l.hidden=true;el("wl-new-more").hidden=true;
    if(w)w.innerHTML='<p class="fh-wl-new-off">'+(why==="key"?"New sign-ups need the hub's access word.":"New sign-ups switch on once sql/HUB-03-FAST-PASS-STEPS-AND-SIGNUPS.sql has been run in Supabase.")+'</p>';
  }
  function newPaint(){
    var d=NEW.data;if(!d)return;
    var c=d.new||{},span=NEW.h?"in the last "+NEW.h+" hours":"in the last "+NEW.d+" days";
    var rows=NEW_WHERE.filter(function(x){return (Number(c[x[0]])||0)>0||x[0]==="product"}).map(function(x){
      return '<span class="fh-wl-new-chip'+(x[0]==="product"?" is-pdp":"")+'"><b>'+(Number(c[x[0]])||0).toLocaleString()+'</b> '+esc(x[1])+'</span>';
    }).join("");
    el("wl-new-where").innerHTML='<p class="fh-wl-new-total"><b>'+(Number(c.all)||0).toLocaleString()+'</b> new '+((Number(c.all)||0)===1?"sign-up":"sign-ups")+' '+span+
      ((Number(d.again)||0)?', and <b>'+Number(d.again).toLocaleString()+'</b> who signed up again':'')+'.</p><div class="fh-wl-new-chips">'+rows+'</div>';
    var byId={};((D&&D.top)||[]).forEach(function(r){byId[r.id]=r});
    var list=(d.recent||[]),l=el("wl-new-list");
    if(!list.length){l.hidden=false;l.innerHTML='<div class="fh-empty" style="padding:16px">Nobody has joined yet.</div>';el("wl-new-more").hidden=true;return}
    l.hidden=false;
    l.innerHTML=list.slice(0,NEW.shown).map(function(x){
      var r=byId[x.id],turn=r?tueTitle(r).replace(/\. .*$/,""):"";
      return '<div class="fh-wl-new-row"><span class="who"><b>'+esc(x.name||"Somebody")+'</b><small>'+esc(newWord(x.src))+(turn?' · '+esc(turn):"")+'</small></span>'+
        '<span class="at" title="'+esc(new Date(x.at).toLocaleString())+'">'+esc(ago(x.at))+'</span></div>';
    }).join("");
    var more=el("wl-new-more");more.hidden=list.length<=NEW.shown;
    more.textContent="Show "+Math.min(24,list.length-NEW.shown)+" more";
  }
  (function(){
    var rng=document.querySelector(".fh-wl-new-rng");
    if(rng)rng.addEventListener("click",function(e){
      var b=e.target.closest("button");if(!b)return;
      Array.prototype.forEach.call(rng.querySelectorAll("button"),function(x){x.classList.toggle("on",x===b)});
      NEW.h=Number(b.getAttribute("data-new-h"))||0;NEW.d=Number(b.getAttribute("data-new-d"))||7;newLoad(true);
    });
    var more=el("wl-new-more");
    if(more)more.addEventListener("click",function(){NEW.shown+=24;newPaint()});
    document.addEventListener("click",function(e){
      var a=e.target.closest&&e.target.closest("[data-open-warm]");if(!a)return;
      var f=el("wl-fold-warm");if(f)f.open=true;
    });
  })();
  window.ffWlSignups=function(){return NEW.data};

  function fpControl(action,body,btn,done){
    if(!key())return;
    if(btn)btn.disabled=true;
    rpc("datahub_fastpass_control",Object.assign({p_key:key(),p_action:action},body)).then(function(d){
      if(!d||d.ok===false){err((d&&d.error==="bad key")?"The access word was not accepted.":(d&&d.error)||"That didn't take. Nothing changed.");return}
      if(done)done(d);
      fpLoad(true);
    }).catch(function(e){err(plainErr(e,"That didn't take. Nothing changed."))})
      .then(function(){if(btn)btn.disabled=false});
  }
  function fpPerson(id,nm,btn){
    fpControl("person",{p_queue_id:id},btn,function(d){
      fpCopy(fpLink(d.code),"Fast pass for "+nm+" copied. Paste it into your text or email: "+fpLink(d.code));
      if(btn){btn.classList.add("done");setTimeout(function(){btn.classList.remove("done")},1600)}
    });
  }
  (function(){
    var host=el("wl-fp"); if(!host)return;
    el("wl-fp-open").textContent=FP_URL.replace(/^https:\/\//,"");
    el("wl-fp-copy-open").addEventListener("click",function(){fpCopy(FP_URL,"The plain fast pass link is copied. Anybody who opens it adds their number to claim a pass.")});
    function make(){
      var input=el("wl-fp-name"),nm=String(input.value||"").replace(/\s+/g," ").trim();
      if(!nm){input.focus();err("Type their first name first.");return}
      fpControl("name",{p_name:nm},el("wl-fp-make"),function(d){
        input.value="";
        fpCopy(fpLink(d.code),"Fast pass for "+nm+" copied. It greets them by name and asks for their number: "+fpLink(d.code));
      });
    }
    el("wl-fp-make").addEventListener("click",make);
    el("wl-fp-name").addEventListener("keydown",function(e){if(e.key==="Enter"){e.preventDefault();make()}});
    el("wl-fp-list").addEventListener("click",function(e){
      var b=e.target&&e.target.closest?e.target.closest("[data-fp]"):null; if(!b)return;
      var what=b.getAttribute("data-fp");
      if(what==="more"){FP.shown+=30;fpPaint();return}
      var row=b.closest(".fh-fp-row"),code=row&&row.getAttribute("data-code"); if(!code)return;
      var p=FP.list.filter(function(x){return x.code===code})[0]||{};
      if(what==="copy")fpCopy(fpLink(code),"Fast pass for "+(p.name||"them")+" copied: "+fpLink(code));
      if(what==="off")fpControl("off",{p_code:code},b,function(){note("That fast pass is off. Its link now says it has ended.")});
      if(what==="on")fpControl("on",{p_code:code},b,function(){note("That fast pass works again.")});
    });
    if(key())fpLoad(true);
  })();

  /* waits politely for the hub gate, then stays fresh */
  var boot=setInterval(function(){if(key()){clearInterval(boot);load()}},1500);
  if(key())load();
  setInterval(function(){if(document.visibilityState==="visible")load()},20000);
})();
